/* eslint-disable eqeqeq */
/* eslint-disable no-unreachable */
/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
import {
  CustomSuccessToast,
  CustomToastIcon,
} from '@/@straico-ui/commons/CustomToasts';
import ImagePreview from '@/Components/Chat/ImagePreview/ImagePreview';
import MenuActionsTextField from '@/Components/Chat/MenuActionsTextField/MenuActionsTextField';
import useChatStore, {
  CAPABILITIES_CHANGE,
  COLUMNS,
  EVENT_ADD_MODEL,
  EVENT_NEW_CHAT,
  EVENT_SELECT_CHAT,
  GRID,
  LOADING_FAV_TOOLS,
  REMOVE_MODEL,
  ROWS,
  SAVE_MERGE,
  SCRIPT_FOR_TTS,
  TABS,
} from '@/Components/Chat/store';
import TextAreaHightlight from '@/Components/Chat/TextAreaHightlight/TextAreaHightlight';
import ChatMessage from '@/Components/Common/Markdown/ChatMessage';
import FavoriteMessages from '@/Components/Common/Markdown/FavoriteMessages';
import ImageMaskEditorModal from '@/Components/Common/Markdown/ImageMaskEditorModal';
import useChatMessageStore from '@/Components/Common/Markdown/store';
import ToggleSmartMode from '@/Components/Common/ToggleSmartMode';
import FileContext from '@/Components/FileContext';
import ImageDialog from '@/Components/ImageDialog';
import Loader from '@/Components/Loader';
import ModelWarningDialog from '@/Components/ModelWarningDialog';
import ScrollableToolsSection from '@/Components/ScrollableToolsSection';
import TextSpeechDialog from '@/Components/TextSpeechDialog';
import WordcapLimitsDialog from '@/Components/WordcapLimitsDialog';
import {
  DEFAULT_OPTIONS_CHAT_TOOLBAR,
  highlightWordsTextAreaV2,
  highlightWordsTextAreaV2Dark,
  IMAGES_TEMPLATES_IDS,
  svgIconBase64,
} from '@/Constants/chat';
import { MAX_MODELS_SELECTION } from '@/Constants/models';
import { useChat } from '@/Context/Chat/Chat.context';
import { useChatMessagesContext } from '@/Context/Chat/ChatMessagesContext';
import AttachedFiles from '@/Features/Core/Components/AttachedFiles/AttachedFiles';
import CapabilityModelValidator from '@/Features/Core/Components/CapabilitySelector/CapabilityModelValidator';
import CapabilitySelector from '@/Features/Core/Components/CapabilitySelector/CapabilitySelector';
import CostInfoModal from '@/Features/Core/Components/ChatPricing/CostInfoModal';
import ClearChat from '@/Features/Core/Components/ClearChat/ClearChat';
import DeleteChat from '@/Features/Core/Components/DeleteChat';
import ListingChatMessages from '@/Features/Core/Components/ListingChatMessages/ListingChatMessages';
import StreamingMessage from '@/Features/Core/Components/StreamingMessage/StreamingMessage';
import TitleBarChat from '@/Features/Core/Components/TitleBarChat/TitleBarChat';
import useAutoScrollChat from '@/Features/Core/logic/useAutoScrollChat';
import useMessages from '@/Features/Core/logic/useMessagesChat';
import useStreamingChat from '@/Features/Core/logic/useStreamingChat';
import useTemplateShare from '@/Features/Core/logic/useTemplateShare';
import { useWelcomeMessage } from '@/Features/Core/logic/useWelcomeMessage';
import ModelsModal from '@/Features/ModelsModal';
import useSmartModeStore from '@/Features/SmartMode/store';
import useCopyWithoutFormat from '@/Hooks/useCopyWithoutFormat';
import useDebounce from '@/Hooks/useDebounce';
import useDisableIOSZoom from '@/Hooks/useDisableIOSZoom';
import useIsMobile from '@/Hooks/useIsMobile';
import CapabilitiesIcon from '@/Theme/icons/capabilitiesIcon';
import PaperClipIcon from '@/Theme/icons/clip';
import {
  ColumnsIcon,
  GridIcon,
  RowsIcon,
  TabsIcon,
} from '@/Theme/icons/sideBySideIcons';
import StraiCoinIcon from '@/Theme/icons/straicoin';
import useThemeStore from '@/Theme/store';
import {
  ArrowLongRightIcon,
  MicrophoneIcon,
  StopIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { Tooltip } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import axios from 'axios';
import ActionsChat from 'Components/Chat/ActionsChat/ActionsChat';
import CoinsAlertModal from 'Components/Chat/CoinsAlertModal';
import useAlertCoinsStore from 'Components/Chat/CoinsAlertModal/store';
import useMenuActionsTextFieldLogic from 'Components/Chat/MenuActionsTextField/hooks/useMenuActionsTextFieldLogic';
import useMenuActionStore from 'Components/Chat/MenuActionsTextField/store';
import PromptLibrary from 'Components/Chat/PromptLibrary';
import usePromptLibraryStore from 'Components/Chat/PromptLibrary/store';
import TemplateModal from 'Components/Chat/TemplateModal';
import DeleteTemplateModal from 'Components/Chat/TemplateModal/components/DeleteTemplateModal';
import useGetTemplateData from 'Components/Chat/TemplateModal/hooks/useGetTemplateData';
import useTemplateModalStore from 'Components/Chat/TemplateModal/store';
import useTextAreaFocus from 'Components/Chat/TextAreaHightlight/state';
import useTreeDNDChatStore from 'Components/Chat/TreeDNDChat/Store';
import { buildDataTreeDNDChat } from 'Components/Chat/TreeDNDChat/Utils/functions';
import useCreateTemplatesStore from 'Features/CreateTemplatesForm/Store';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useAudioRecorder } from 'react-audio-voice-recorder';
import { Helmet } from 'react-helmet';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { sortArrayAlphabetically, sortByAttribute } from 'utils/commons';
import { toastReward } from 'utils/toastCall';
import { parseQueryString } from 'utils/urlParse';
import DownloadChat, {
  downloadTxtFile,
  formatChatDataForTxt,
  generatePDF,
} from './Components/DownloadChat/DownloadChat';
import EditTitle from './Components/EditTitle';
import ShareChat from './Components/ShareChat/ShareChat';
import useCatalog from './logic/useCatalog';
import { Shortcut } from './styled';
import { formatedDate, formatTime } from './utils/format';
import useModalPromise from './utils/useModalPromise';

let onNewChat;

const Chat = ({ store }) => {
  useCopyWithoutFormat();
  useDisableIOSZoom();

  // Location and navigation
  const location = useLocation();
  const navigate = useNavigate();

  // Media query for mobile
  const isMobile = useIsMobile();

  // -------------------------------- HOOK TO MANAGE MESSAGES --------------------------------
  const {
    messages,
    setMessages,
    setStreamingMessage,
    setLoading,
    loading,
    capabilities,
    setCapabilities,
  } = useChatMessagesContext();
  const {
    userMessage,
    addMessage,
    clearMessages,
    replaceFirstMessage,
    replaceMessage,
    removeLastMessage,
    updateDummyMessage,
    createDummyMessage,
    updateStreamingMessages,
    addContentStop,
  } = useMessages();
  // ------------------------------------------- END --------------------------------

  // -------------------------------- HOOK TO MANAGE MESSAGES --------------------------------
  const { welcomeMessage } = useWelcomeMessage();
  // ------------------------------------------ END ------------------------------------------

  const [inputError] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const inputContainerRef = useRef(null);

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showDownloadDialog, setShowDownloadDialog] = useState(false);
  const [toDelete, setToDelete] = useState(null);
  const [avatar, setAvatar] = useState(null);
  const [deleted, setDeleted] = useState(false);
  const [cleared, setCleared] = useState(false);

  const [showFileDialog, setShowFileDialog] = useState(false);
  const [showTextSpeechDialog, setShowTextSpeechDialog] = useState(false);
  const [showClearDialog, setShowClearDialog] = useState(false);
  const [showCapabilitiesDialog, setShowCapabilitiesDialog] = useState(false);

  const [showWarningDialog, setShowWarningDialog] = useState(false);
  const [showLimitDialog, setShowLimitDialog] = useState(false);
  const [runSampleAutoFlag, setRunSampleAutoFlag] = useState(false);
  const { setOpenModal: setCreateTemplateModalOpenMenuAction } = useCreateTemplatesStore();

  const [loadingBar, setLoadingBar] = useState(false);
  const [axiosSource, setAxiosSource] = useState(null);
  const [optimizing, setOptimizing] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [currentTemplateModels, setCurrentTemplateModels] = useState([]);
  // Pricing per Message
  const [costModalOpen, setCostModalOpen] = useState(false);
  const PPI_CONFIG = {
    multiplier: parseFloat(import.meta.env.VITE_PPI_MULTIPLIER || '15'),
    includeImageCost: import.meta.env.VITE_PPI_INCLUDE_IMAGE_COST === 'true',
  };

  const dummy = useRef(null);
  const chatId = useRef(null);
  const isProcessing = useRef(false);

  const [scriptValue, setScriptValue] = useState(null);

  const setSelectedModels = (models, sort = true) => {
    oldSelectedModels.current = sort
      ? sortByAttribute(models, 'abbreviation')
      : models;
    updateSelectedModels(() =>
      sort ? sortByAttribute(models, 'abbreviation') : models
    );
    localStorage.setItem('currentModels', JSON.stringify(models));
    // For editing a message
    setEditMessChange();
  };

  const [filteredOptions, setFilteredOptions] = useState(
    DEFAULT_OPTIONS_CHAT_TOOLBAR
  );

  /**
   * --------------------------------------
   * LOGIC THAT OPEN THE TEMPLATE MODAL AND
   * GET THE DATA FROM THE TEMPLATE
   */
  useGetTemplateData(store);
  // --------------------------------------

  useEffect(() => {
    if (!inputValue) {
      setFilteredOptions(DEFAULT_OPTIONS_CHAT_TOOLBAR);
    } else {
      const sanitizedInput = inputValue
        .toLowerCase()
        .replace(/[^a-z0-9 ]/g, '');
      const updatedOptions = DEFAULT_OPTIONS_CHAT_TOOLBAR.map((option) => ({
        ...option,
        isHidden: !option.name.toLowerCase().includes(sanitizedInput),
      }));
      setFilteredOptions(updatedOptions);
    }
  }, [inputValue]);

  const { setEditMessChange, editMessChange } = useChatMessageStore();

  // Url params control
  const setChatUrlValue = (value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('selectedTool');
    searchParams.set('chat', value);
    const newSearch = `?${searchParams.toString()}`;
    navigate(`${location.pathname}${newSearch}`, { shallow: true });
  };

  const removeChatUrlValue = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('chat');
    const newSearch = `?${searchParams.toString()}`;
    navigate(`${location.pathname}${newSearch}`, { shallow: true });
  };

  // activate delete dialog
  const {
    openDeleteChatModal,
    setOpenDeleteChatModal,
    openClearChatModal,
    setOpenClearChatModal,
    toDelete: toDeleteDND,
    setToDelete: setToDeleteDND,
  } = useTreeDNDChatStore();

  useEffect(() => {
    if (openDeleteChatModal) {
      setShowDeleteDialog(true);
      setOpenDeleteChatModal(false);
    }
  }, [openDeleteChatModal]);

  useEffect(() => {
    if (openClearChatModal) {
      setShowClearDialog(true);
      setOpenClearChatModal(false);
    }
  }, [openClearChatModal]);

  useEffect(() => {
    if (toDeleteDND) {
      setToDelete(toDeleteDND);
    }
  }, [toDeleteDND]);

  // Context
  const {
    lastestPrompt,
    lastestTool,
    cleanLastestFields,
    setValuesAfterInsert,
    tools,
    promptListRef,
    currentIndexMenuAction,
    textareaRef,
    toggleShowPromptSide,
    getToolsAndFilter,
    activePromptIndex,
    setActivePromptIndex,
    selectedTool,
    setSelectedPrompt,
    getPromptsByTool,
    toggleShowPromptModal,
    setShowMobileChats,
    setShowMobilePrompts,
    handleShowMobilePrompts,
    getToolsAndFilterSidebar,
    setShowConversationsSide,
    interactionsCount,
    hasTriggeredGuide,
    incrementInteractions,
  } = useChat();

  const {
    isOpen: isModelValidatorOpen,
    open: openModelValidator,
    close: closeModelValidator,
  } = useModalPromise();

  const { templatesChatList, openMenuAction, setOpenMenuAction } =
    useMenuActionStore();

  /**
   * This is the logic to manage open the template modal
   */
  const {
    openModal: openModalTemplate,
    isTemplatePrompt,
    setIsTemplatePrompt,
    setTemplateData,
  } = useTemplateModalStore();

  const chatList = useChatStore((state) => state.chatList);
  const openShareChatModal = useChatStore((state) => state.shareChat);
  const selectedChat = useChatStore((state) => state.selectedChat);
  const setChatsList = useChatStore((state) => state.setChatsList);
  const setSelectedChat = useChatStore((state) => state.setSelectedChat);
  const cleanSelectedChat = useChatStore((state) => state.cleanSelectedChat);
  const setChatWords = useChatStore((state) => state.setChatWords);
  const maxMessageModels = useChatStore((state) => state.maxMessageModels);
  const setMaxMessageModels = useChatStore(
    (state) => state.setMaxMessageModels
  );
  const refFile = useChatStore((state) => state.refFile);
  const setRefFile = useChatStore((state) => state.setRefFile);
  const updateRefFile = useChatStore((state) => state.updateRefFile);
  const powerPanelOpen = useChatStore((state) => state.powerPanelOpen);
  const selectedModels = useChatStore((state) => state.selectedModels);
  const updateSelectedModels = useChatStore(
    (state) => state.updateSelectedModels
  );
  const showModelsDialog = useChatStore((state) => state.showModelsDialog);
  const setShowModelsDialog = useChatStore(
    (state) => state.setShowModelsDialog
  );
  const runEvent = useChatStore((state) => state.runEvent);
  const addEvent = useChatStore((state) => state.addEvent);
  const currentEvent = useChatStore((state) => state.currentEvent);
  const renderType = useChatStore((state) => state.renderType);
  const setRenderType = useChatStore((state) => state.setRenderType);
  const headerVisible = useChatStore((state) => state.headerVisible);
  const hideOnHover = useChatStore((state) => state.hideOnHover);
  const setHideOnHover = useChatStore((state) => state.setHideOnHover);
  const addResponseModels = useChatStore((state) => state.addResponseModels);
  const setAddResponseModels = useChatStore(
    (state) => state.setAddResponseModels
  );
  const replaceResponse = useChatStore((state) => state.replaceResponse);
  const setReplaceResponse = useChatStore((state) => state.setReplaceResponse);
  const setShareChat = useChatStore((state) => state.setShareChat);
  const [selectedModelsId, setSelectedModelsId] = useState([]);

  // -------------------------------- HOOK TO MANAGE STREAMING -----------------------
  const { stopped, onStop, cancelChat } = useStreamingChat({
    store,
    selectedChat,
    chatId,
    axiosSource,
    setAxiosSource,
    updateStreamingMessages,
    loading,
    addContentStop,
    userMessage,
    setCancel,
  });
  // ------------------------------------------- END --------------------------------

  // -------------------------------- HOOK TO MANAGE AUTO SCROLL -----------------------
  const {
    chatContainer,
    setAutoScroll,
    messageRefs,
    handleScroll,
    handleScrollRequest,
    goToDown,
    scrollToMessage,
  } = useAutoScrollChat();
  // ------------------------------------------- END --------------------------------

  // Folder manage STATE
  const { treeData, setTreeData, setPage, setTotalPage } =
    useTreeDNDChatStore();

  // Images variables
  const [imagesPreview, setImagesPreview] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [params, setParams] = useState({});
  const [behaviours, setBehaviours] = useState([]);
  const [attrs, setAttrs] = useState({});
  const [currentPrompt, setCurrentPrompt] = useState(null);
  const [showImageDialog, setShowImageDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState('');

  //id of chat
  const [xchatId, setXchatId] = useState(null);

  const lastModel = useRef(null);
  const toolData = useRef(null);
  const streamCode = useRef(null);
  const loadingResponse = useRef(false);

  const { smartMode } = useSmartModeStore();

  useEffect(() => {
    if (window.innerWidth <= 768) {
      fetchFavs();
    }
  }, []);

  useEffect(() => {
    setFavTools(store.favtools);
  }, [store.favtools]);

  useEffect(() => {
    getToolsAndFilterSidebar('');
  }, []);

  useEffect(() => {
    if (currentEvent) {
      eventActions(currentEvent);
    }
  }, [currentEvent]);

  const eventActions = (event) => {
    switch (event.name) {
      case EVENT_NEW_CHAT:
        runEvent(onNewChat);
        break;
      case EVENT_SELECT_CHAT:
        runEvent(onSelectChat);
        break;
      case SCRIPT_FOR_TTS:
        runEvent(handleScriptForTTS);
        break;
      case REMOVE_MODEL:
        runEvent(removeModel);
        break;
      case SAVE_MERGE:
        runEvent(setChat);
        break;
      case LOADING_FAV_TOOLS:
        runEvent(fetchFavs);
        break;
      case EVENT_ADD_MODEL:
        runEvent(handleReplaceModels);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setAvatar(store.profile.avatar.svg);
    setShowConversationsSide(true);
    if (!isMobile) {
      toggleShowPromptSide();
    }
  }, []);

  const oldSelectedModels = useRef(null);
  useEffect(() => {
    if (!addResponseModels) {
      updateDummyMessage(oldSelectedModels.current ?? []);
      streamCode.current = btoa(JSON.stringify(oldSelectedModels.current));
    }
  }, [selectedModels]);

  const getChats = async () => {
    setLoadingBar(true);
    setLoading(true);
    try {
      const res = await store.api.get(`/chat/v1/folders?page_number=${1}`);
      const data = await res.data;
      const chats = data.chats;

      setPage(data.currentPage);
      setTotalPage(data.totalPages);

      const newTree = buildDataTreeDNDChat(chats);
      setTreeData(newTree);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setLoading(false);
      setLoadingBar(false);
    }
  };

  /**
   * Get chat by hash from url
   * @param {string} hash
   * @returns
   */
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      const hash = parseQueryString(location.search)?.chat;
      if (hash !== selectedChat?.chat?._id) {
        if (hash && chatList?.length > 0) {
          getChat(hash);
          setShowMobileChats(false);
        } else if (hash) {
          getChat(hash);
        }
      }

      isFirstLoad.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getChat = async (hash, messageIdentifier = null, isUser = null) => {
    setLoadingBar(true);
    setChatWords(0);

    try {
      let hashShared = null;
      if (sessionStorage.getItem('redirectUrl')) {
        const res = await store.api.post(`/chat/clone/${hash}`);
        const data = await res.data;
        hashShared = data?.chat?._id;
        sessionStorage.removeItem('redirectUrl');
      }
      const localHash = hashShared ?? hash;
      // add query params url
      setChatUrlValue(localHash);
      const res = await store.api.get('/chat/' + localHash);
      setChat(res.data.chat);
      setMessages(res?.data?.chat?.messages ?? []);
      setXchatId(localHash);
      if (res.data.chat.files) {
        setRefFile(res.data.chat.files);
      }

      if (res.data.chat.messages && res.data.chat.messages.length) {
        countTotalWords(res.data.chat.messages);
        try {
          const lastMessage = res.data.chat.messages[0];
          lastModel.current = Array.isArray(lastMessage)
            ? lastMessage.find((r) => r.selected)?.modelRef
            : lastMessage.modelRef;
          const modelRef = Array.isArray(lastMessage)
            ? lastMessage.map((m) => m.modelRef)
            : lastMessage.modelRef;
          const response = await store.api.get('/model/byId', {
            params: {
              default_model_template: modelRef,
            },
          });
          if (response.data.model.length > 0) {
            if (store.profile.plan == 'free') {
              try {
                const response2 = await store.api.get(`/model`);
                let availableModels = response2.data.models;

                const res = await store.api.get('/user/constant', {
                  params: {
                    type: 'princing_plans',
                  },
                });
                let freePlanModels = []; // Array to store models allowed for free users

                freePlanModels = res.data.rules[0].models;

                const modelsInFreePlan = []; // Array to store models available for free users
                const otherModels = []; // Array to store models not available for free users

                availableModels.forEach((model) => {
                  if (freePlanModels.includes(model.model)) {
                    modelsInFreePlan.push(model);
                  } else {
                    otherModels.push(model);
                  }
                });

                let filterModels = modelsInFreePlan.filter((model) =>
                  response.data.model.map((m) => m._id).includes(model._id)
                );

                if (filterModels.length >= 1) {
                  setSelectedModels(response.data.model);
                } else {
                  setSelectedModels([availableModels[0]]);
                }
              } catch (error) {
                console.error(error);
              }
            } else {
              setSelectedModels(response.data.model);
            }
            localStorage.setItem(
              'currentModels',
              JSON.stringify(response.data.model)
            );
          } else {
            let defaultModel = localStorage.getItem('defaultModel');
            if (defaultModel) {
              setSelectedModels([JSON.parse(defaultModel)]);
            }
          }
        } catch (error) {
          console.error(error);
        }
      }

      // If messageIdentifier is passed, scroll to that message
      if (messageIdentifier !== null && isUser !== null) {
        scrollToMessage(messageIdentifier, isUser);
      } else {
        goToDown();
      }
    } catch (error) {
      removeChatUrlValue();
      console.error(error);
    } finally {
      setLoadingBar(false);
    }
  };

  const countTotalWords = (messages) => {
    let chatWordsCount = 0;
    let maxModels = maxMessageModels;

    messages.forEach((item) => {
      // count models
      let models = Array.isArray(item) ? item.length : 1;
      if (models > maxModels) {
        setMaxMessageModels(models);
      }

      // Get selected message
      let temp = Array.isArray(item)
        ? item.filter((m) => m.selected == true)
        : [item];
      let msg = temp.length > 0 ? temp[0] : null;

      if (msg && msg.data && msg.data.content) {
        if (typeof msg.data.content == 'string') {
          const wordsContent = store.countWords(msg.data.content);
          chatWordsCount += wordsContent;
        } else {
          for (let content of msg.data.content) {
            if (content.type == 'text') {
              const wordsContent = store.countWords(content.text);
              chatWordsCount += wordsContent;
            } else if (content.type == 'image_url') {
              const visionModel = selectedModels.some(
                (model) => model.type == 'vision'
              );
              chatWordsCount += visionModel ? content.image_url.words : 0;
            }
          }
        }
      }
    });
    setChatWords(chatWordsCount);
  };

  // redirect to path with query
  const redirectToPathWithQuery = (query) => {
    navigate(
      {
        pathname: location.pathname,
        search: new URLSearchParams({
          ...parseQueryString(location.search, query),
        }).toString(),
      },
      { shallow: true }
    );
  };
  // go back chat
  const goBackChat = () => {
    redirectToPathWithQuery(location.pathname, parseQueryString('chat'));
    dummy.current = { _id: null, messages: [] };
    clearMessages();
    cleanSelectedChat();
    setRefFile(null);
  };
  // set chat
  const setChat = (chat, identifier = null) => {
    setSelectedChat(chat);
    dummy.current = chat;
    if (identifier) scrollToMessage(identifier, false, 'auto');
  };

  const containsVisionModel = () => {
    return (
      selectedModels.length &&
      selectedModels.some((model) => model.type === 'vision')
    );
  };

  const { setOpenModal: setCoinsAlertOpen, dissmissed: dissmissedAlertCoins } =
    useAlertCoinsStore();

  const handleConfirmAlertCoins = () => {
    onSend(null, undefined, undefined, undefined, true);
    setCoinsAlertOpen(false);
  };
  const handleCloseAlertCoins = () => { };

  const continueResponse = () => {
    onSend(null, 'continue', undefined, undefined, true);
  };

  const optimizePrompt = async (originalPrompt) => {
    if (!originalPrompt || originalPrompt.trim() === '') {
      console.warn('The originalPrompt is not valid for optimization');
      return {
        optimizedPrompt: originalPrompt,
        LLMRole: '',
        basePrompt: '',
        systemInstructions: '',
      };
    }

    try {
      const chatId = selectedChat?.chat || null;
      const responseOptimization = await store.api.post(
        `/ai/chat/optimize-prompt`,
        {
          originalPrompt: originalPrompt,
          coins: 10,
          chatId: chatId,
        }
      );

      if (!responseOptimization.data.success) {
        if (responseOptimization.data.error === 'missing_coins') {
          toastReward({
            title: 'Missing coins',
            message: 'Recharge your account on the profile page',
            linkText: "It's quick and easy. Click here!",
            linkUrl: '/my-profile/pricing',
            image: '/gifs/coin.gif',
            time: 10000,
          });
          return {
            optimizedPrompt: originalPrompt,
            LLMRole: '',
            basePrompt: '',
            systemInstructions: '',
          };
        } else {
          toast.error(responseOptimization.data.error);
          return {
            optimizedPrompt: originalPrompt,
            LLMRole: '',
            basePrompt: '',
            systemInstructions: '',
          };
        }
      }
      const basePrompt = responseOptimization.data.basePrompt;
      const systemInstructions = responseOptimization.data.systemInstructions;
      const needsOptimization = responseOptimization.data.needsOptimization;
      if (!needsOptimization) {
        const truncateText = (text, maxLength) => {
          if (text.length <= maxLength) return text;
          const words = text.split(' ');
          let truncated = '';
          for (let word of words) {
            if ((truncated + word).length > maxLength) break;
            truncated += (truncated ? ' ' : '') + word;
          }
          return truncated.trim() + '...';
        };
        const displayPrompt = truncateText(originalPrompt, 30);

        const customToastOptions = {
          style: {
            background: '#D4D5E6',
            color: '#000',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            padding: '16px',
            display: 'flex',
            alignItems: 'center',
            width: isMobile ? '100%' : 'auto',
            maxWidth: isMobile ? '100%' : '30%',
            minWidth: isMobile ? '100%' : '20%',
          },
          icon: (
            <img
              src={svgIconBase64}
              alt="Lightning Icon"
              width={isMobile ? '20' : '24'}
              height={isMobile ? '20' : '24'}
              style={{
                marginRight: '8px',
                filter:
                  'invert(34%) sepia(96%) saturate(5500%) hue-rotate(245deg) brightness(60%) contrast(95%)',
              }}
            />
          ),
          duration: 2000,
          position: isMobile ? 'top-center' : 'top-right',
        };

        toast(
          <div>
            <div
              style={{
                fontWeight: 700,
                fontSize: isMobile ? '16px' : '16px',
                marginBottom: '4px',
                color: '#5256A6',
                fontFamily: 'Figtree, sans-serif',
              }}
            >
              Smart Mode – Prompt Optimization
            </div>
            <div
              style={{
                fontSize: isMobile ? '14px' : '14px',
                color: '#6B6B6B',
              }}
            >
              Prompt "<strong>{displayPrompt}</strong>" was not optimizable
            </div>
          </div>,
          customToastOptions
        );
        return {
          optimizedPrompt: originalPrompt,
          LLMRole: '',
          needsOptimization,
          basePrompt: basePrompt,
          systemInstructions: systemInstructions,
        };
      }

      if (responseOptimization?.data?.optimizedPrompt) {
        let finalPrompt = `${responseOptimization.data.optimizedPrompt}`;
        let LLMRole = responseOptimization.data.role;

        if (
          responseOptimization.data.importantContent &&
          responseOptimization.data.importantContent !== 'N/A'
        ) {
          const originalPromptNoSpaces = originalPrompt.replace(/\s+/g, '');
          const importantContentNoSpaces =
            responseOptimization.data.importantContent.replace(/\s+/g, '');

          if (originalPromptNoSpaces !== importantContentNoSpaces) {
            finalPrompt += `\n\n${responseOptimization.data.importantContent}`;
          }
        }

        return {
          optimizedPrompt: finalPrompt,
          LLMRole: LLMRole,
          needsOptimization,
          basePrompt: basePrompt,
          systemInstructions: systemInstructions,
        };
      } else {
        return {
          optimizedPrompt: originalPrompt,
          LLMRole: '',
          needsOptimization,
          basePrompt: basePrompt,
          systemInstructions: systemInstructions,
        };
      }
    } catch (error) {
      console.error(error);
      return {
        optimizedPrompt: originalPrompt,
        LLMRole: '',
        basePrompt: '',
        systemInstructions: '',
      };
    }
  };

  useEffect(() => {
    const currentModels = localStorage.getItem('currentModels');
    if (currentModels) {
      const parsedModels = JSON.parse(currentModels);
      setSelectedModelsId(parsedModels.map((model) => model._id));
    } else {
      setSelectedModelsId(selectedModels.map((model) => model._id));
    }
  }, [selectedModels]);

  // on send message
  const onSend = async (
    e,
    inputText = undefined,
    modelsId = undefined,
    files,
    proceedCoins = false,
    editData = null
  ) => {
    let inputVal = inputValue;
    let originalPrompt = null;
    let displayedPrompt = false;
    let finalModelsId = null;

    // Validate if is loading or optimizing
    if (isProcessing.current) {
      toast('Wait a moment, the chat is being processed', {
        icon: '📢',
      });
      return;
    }

    const requiredCoins = calculateCoins(getChatWords(inputValue));
    // Check if the user has enough coins
    if (store.profile.credits < requiredCoins) {
      toastReward({
        title: 'Missing coins',
        message: 'Recharge your account on the profile page',
        linkText: "It's quick and easy. Click here!",
        linkUrl: '/my-profile/pricing',
        image: '/gifs/coin.gif',
        time: 10000,
      });
      return;
    }

    // Alert user if the message is over 1000 coins
    if (!dissmissedAlertCoins) {
      const coins = calculateCoins(getChatWords(inputValue));

      if (coins >= 1000) {
        setCoinsAlertOpen(true);
        if (!proceedCoins) {
          return;
        }
      }
    }

    let currentModelsStr = localStorage.getItem('currentModels');
    let parsedModels = JSON.parse(currentModelsStr);
    let currentModelIds = parsedModels.map((model) => model._id);

    if (capabilities && !isTemplatePrompt) {
      const incompatibleModels = selectedModels.filter((model) =>
        capabilities.some(
          (capability) =>
            !model.function_calls?.some(
              (func) => func.capability === capability._id
            )
        )
      );

      if (
        incompatibleModels.length > 0 &&
        capabilities.length > 0 &&
        !modelsId
      ) {
        await openModelValidator();
      }
      setSelectedModelsId(currentModelIds);
      currentModelsStr = localStorage.getItem('currentModels');
      parsedModels = JSON.parse(currentModelsStr);
      currentModelIds = parsedModels.map((model) => model._id);
      if (currentModelsStr) {
        finalModelsId = selectedModelsId.filter((id) =>
          currentModelIds.includes(id)
        );
      }
    }

    if (smartMode === 'on' && !isTemplatePrompt && inputVal) {
      originalPrompt = inputVal;
      displayedPrompt = true;
    }

    if (displayedPrompt) {
      setChat({
        ...selectedChat?.chat,
      });
    } else {
      setInputValue('');
    }

    let LLMRole = '';
    let basePrompt = '';
    let systemInstructions = '';

    if (displayedPrompt) {
      setOptimizing(true)
      isProcessing.current = true;
      const toasId = toast.loading('Optimizing prompt, wait a moment...', {
        position: 'top-center',
        duration: 15000,
        style: {
          border: '1px solid',
          backgroundColor: themeValue === 'dark' ? '#4f4642' : '#ffefe5',
          color: themeValue === 'dark' ? 'white' : 'black',
          borderColor: themeValue === 'dark' ? '#f2a474' : '#f2a474',
        },
      });
      try {
        const optimizationResult = await optimizePrompt(originalPrompt);
        inputVal = optimizationResult.optimizedPrompt;
        LLMRole = optimizationResult.LLMRole;
        basePrompt = optimizationResult.basePrompt;
        systemInstructions = optimizationResult.systemInstructions;
        const needsOptimization = optimizationResult.needsOptimization;
        if (!needsOptimization) {
          originalPrompt = null;
        }
      } finally {
        setInputValue('');
        isProcessing.current = false;
        toast.dismiss(toasId);
        handleOptimizationComplete();
      }
    }

    // -----------------------------------------------------------
    setLoading(true);
    setIsTemplatePrompt(false);

    if (inputText) {
      inputVal = inputText;
    }
    stopped.current = false;

    oldSelectedModels.current = selectedModels;

    // Validate if the user message is not null or empty
    if (!inputVal || inputVal.trim() === '') {
      toast("Don't forget: Messages need text too!", {
        icon: '😱',
      });
      return;
    }

    // Send the message logic    
    onCloseBoth();
    isProcessing.current = true;
    loadingResponse.current = true;

    const date = moment().utc();
    const intputSend = containsVisionModel() ? visionInput(inputVal) : inputVal;
    const oldInputValue = inputVal;
    const oldImagesPreview = imagesPreview;

    try {
      const userInput = {
        user: store.profile._id,
        data: {
          role: 'user',
          content: intputSend,
          originalPrompt: originalPrompt,
          LLMRole: LLMRole,
          basePrompt: basePrompt,
          systemInstructions: systemInstructions,
        },
        date: date,
      };

      const tool = lastestTool;
      const prompt = lastestPrompt;

      addMessage(userInput);
      if (!Object.values(IMAGES_TEMPLATES_IDS)?.includes(tool?._id)) {
        setStreamingMessage(createDummyMessage(parsedModels));
      }

      userMessage.current = userInput;
      setChat({
        ...selectedChat?.chat,
      });

      cleanLastestFields();
      setImagesPreview([]);
      setAutoScroll(true);

      if (Object.values(IMAGES_TEMPLATES_IDS)?.includes(tool?._id)) {
        toast(
          'Note: Image generation may take a few minutes. Thank you for your patience.',
          {
            icon: '⏳',
          }
        );
      }

      const notNew = Boolean(selectedChat.chat._id);
      const source = axios.CancelToken.source();
      setAxiosSource(source);

      const timeout = setTimeout(() => {
        if (!cancel) {
          source.cancel();
          toast.error('The chat is taking too long to respond, try again.');
          setLoading(false);
          loadingResponse.current = false;
          setAxiosSource(null);
        }
      }, 4500 * 60);

      let filesTosend = null;

      if (refFile) {
        filesTosend = refFile;
      } else if (!refFile && typeof files !== 'undefined') {
        if (files.length > 0) {
          filesTosend = files;
        }
      }

      if (modelsId) {
        setSelectedModelsId(modelsId);
        if (!finalModelsId) finalModelsId = modelsId;
      }
      updateDummyMessage(finalModelsId ?? selectedModelsId);

      let maskDataUrl;
      let constructedData;

      if (editData) {
        constructedData = [
          {
            type: 'image_url',
            image_url: {
              url:
                editData.find((data) => data.type === 'image_url')?.image_url ||
                '',
              words: calculateCoins(getChatWords(inputVal)),
            },
          },
          {
            type: 'text',
            text: inputVal,
          },
        ];

        maskDataUrl =
          editData.find((data) => data.type === 'mask_url')?.mask_url || '';
      }
      // Determine which endpoint to use based on pricing method
      const endpoint =
        store.profile.pricing_method === 'perMessage'
          ? '/ai/chatRAG'
          : '/ai/chat';

      const response = await store.api.post(
        endpoint,
        {
          message: editData ? constructedData : intputSend,
          maskDataUrl: editData ? maskDataUrl : null,
          originalPrompt: originalPrompt,
          LLMRole: LLMRole,
          basePrompt: basePrompt,
          systemInstructions: systemInstructions,
          idTool: tool?._id,
          hash: selectedChat?.chat?._id,
          date: date,
          files: filesTosend,
          idModel: finalModelsId ?? selectedModelsId,
          coins: calculateCoins(getChatWords(inputVal)),
          params: params,
          behaviours: behaviours,
          currentPrompt: currentPrompt ? currentPrompt.name : null,
          capabilities: capabilities.map((capability) => capability._id),
          source: 'web',
          version: import.meta.env.VITE_WEB_VERSION,
          ...attrs,
        },
        { cancelToken: source.token }
      );

      if (Object.values(IMAGES_TEMPLATES_IDS)?.includes(tool?._id)) {
        addMessage(response.data.message);
      } else {
        replaceFirstMessage(response.data.message);
      }

      clearTimeout(timeout);
      loadingResponse.current = false;
      if (!notNew || selectedChat?.chat?.isShared) await getChats();

      if (!response.data.success) {
        if (
          response.data.error === 'no_coins' ||
          response.data.error === 'missing_coins'
        ) {
          toastReward({
            title: 'Missing coins',
            message: 'Recharge your account on the profile page',
            linkText: "It's quick and easy. Click here!",
            linkUrl: '/my-profile/pricing',
            image: '/gifs/coin.gif',
            time: 10000,
          });
        }
      } else {
        if (tool && prompt) {
          await store.api.post(`/chat-analyze/create`, {
            tool: tool?._id,
            prompt: prompt?._id,
            chat: response.data.hash,
          });
        }

        setChatUrlValue(response.data.hash);
        setXchatId(response.data.hash);

        const currentChat = selectedChat;
        const obj = {
          ...currentChat?.chat,
          _id: response.data.hash,
          title: response.data?.title,
          messages: [
            Array.isArray(response.data.message)
              ? [...response.data.message]
              : { ...response.data.message },
            {
              user: store.profile._id,
              data: {
                role: 'user',
                content: intputSend,
                originalPrompt: originalPrompt,
                basePrompt: basePrompt,
                systemInstructions: systemInstructions,
              },
              date: date,
              tool: tool ? tool._id : null,
            },
            ...(messages ?? []),
          ],
        };
        setChat(obj);

        const newChat = {
          id: obj._id,
          parent: 0,
          droppable: false,
          text: obj?.title || '',
          data: {
            _id: obj._id,
            type: 'chat',
            last_modified: new Date(),
          },
        };

        const updatedTreeData = notNew
          ? treeData.map((item) => {
            if (item.id === obj._id) {
              return { ...item, text: obj.title };
            }
            return item;
          })
          : [...treeData, newChat];

        setTreeData(updatedTreeData);

        // Flux Pro: NSFW content detection
        if (tool?._id == '66c786d7e26442bc593e575d') {
          if (Array.isArray(response?.data?.message?.data?.content)) {
            const contentArray = response.data.message.data.content;
            const hasNsfw = contentArray.some((item) => item?.nsfw === true);

            if (hasNsfw) {
              toast(
                'Warning: NSFW content detected. Please revise your prompt and try again.',
                {
                  icon: '🔞',
                }
              );
            }
          }
        }

        if (obj.messages.length) {
          countTotalWords(obj.messages);
        }

        userMessage.current = null;
        setParams({});
        setBehaviours([]);
        setAttrs({});
        setCurrentPrompt(null);
        updateDummyMessage(selectedModels);
      }
      if (store.profile.plan === 'free') {
        incrementInteractions();
        // Parameter Number of interactions to trigger the guide (2)
        if (!hasTriggeredGuide && interactionsCount + 1 >= 2) {
          window.userGuiding.previewGuide(135019); // User Guide
        }
      }
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast(error?.response?.data?.error?.message, {
          icon: '⚠️',
        });
      }
      if (!stopped.current) {
        setMessages((prev) => [...(prev ?? []).filter((m) => m.date != date)]);
        setInputValue(oldInputValue);
        setImagesPreview(oldImagesPreview);
      } else {
        setLoading(true);
        loadingResponse.current = true;
        await store.refreshTokenAndProfileCoins();
        await getChat(chatId.current);
      }
      checkUseTool();
    } finally {
      setLoading(false);
      isProcessing.current = false;
      loadingResponse.current = false;
      goToDown();
      setAxiosSource(null);
    }
  };

  const handleAddModels = () => {
    setAddResponseModels(true);
    setShowModelsDialog(true);
  };

  const handleReplaceModels = async (model) => {
    const position = replaceResponse
      ? messages.findIndex(
        (elem) =>
          (!Array.isArray(elem) &&
            elem._id &&
            elem._id == replaceResponse._id) ||
          (Array.isArray(elem) &&
            elem.some((e) => e._id == replaceResponse._id))
      )
      : 0;
    if (position == 0) {
      onAddModels([...selectedModels, model]);
      return;
    }

    try {
      const response = await store.api.get(`/model`);
      const availableModels = response.data.models;
      const message = Array.isArray(messages[position])
        ? messages[position]
        : [messages[position]];
      const modelsIds = message.map((m) => m.modelRef);
      const responseModels = availableModels.filter((m) =>
        modelsIds.includes(m._id)
      );
      onAddModels([...responseModels, model]);
    } catch (error) {
      console.error(error);
      onAddModels([model]);
    }
  };

  const getNewModels = (models) => {
    let finalModels = models;
    if (replaceResponse) {
      finalModels = models.filter((m) => m._id != replaceResponse.modelRef);
    }
    return finalModels;
  };

  const onAddModels = async (newModels) => {
    if (!selectedChat.chat._id) {
      toast.error('Something went wrong. Please try again.');
      return;
    }
    const position = replaceResponse
      ? messages.findIndex(
        (elem) =>
          (!Array.isArray(elem) &&
            elem._id &&
            elem._id == replaceResponse._id) ||
          (Array.isArray(elem) &&
            elem.some((e) => e._id == replaceResponse._id))
      )
      : 0;
    const filterModels = getNewModels(newModels);

    onCloseBoth();
    stopped.current = false;
    const date = moment().utc();

    try {
      const messageArr = Array.isArray(messages[position])
        ? messages[position]
        : [messages[position]];
      const uniqueNewModels = newModels.filter(
        (model) =>
          !messageArr.some((selected) => selected.modelRef === model._id)
      );

      if (uniqueNewModels.length === 0) return;

      let lastMessage = messages[position];
      const indexToInsertAfter =
        Array.isArray(lastMessage) && replaceResponse
          ? lastMessage.findIndex((msg) => msg._id === replaceResponse._id)
          : -1;
      let order;
      if (position == 0) {
        const modelIds = Array.isArray(lastMessage)
          ? lastMessage.map((m) => m.modelRef)
          : [lastMessage.modelRef];
        const intersection = filterModels.filter(
          (m) => !modelIds.some((id) => m._id == id)
        );
        order =
          indexToInsertAfter !== -1
            ? [
              ...modelIds.slice(0, indexToInsertAfter + 1),
              ...intersection.map((i) => i._id),
              ...modelIds.slice(indexToInsertAfter + 1),
            ]
            : [...modelIds, ...intersection.map((i) => i._id)];
        const orderedFilterModels = order
          .map((id) => filterModels.find((m) => m._id == id))
          .filter(Boolean);
        setSelectedModels(orderedFilterModels, false);
        updateDummyMessage(orderedFilterModels, lastMessage, true);
        await additionalConfig(lastMessage);
        removeLastMessage();
      } else {
        const copyLastMessage = JSON.parse(JSON.stringify(lastMessage));
        const replacement = uniqueNewModels.map((m) => {
          return {
            model: m.abbreviation,
            modelRef: m._id,
            data: '',
            finished: false,
          };
        });
        const dummy = Array.isArray(lastMessage)
          ? indexToInsertAfter !== -1
            ? [
              ...lastMessage.slice(0, indexToInsertAfter + 1),
              ...replacement,
              ...lastMessage.slice(indexToInsertAfter + 1),
            ]
            : [...lastMessage, ...replacement]
          : [{ ...lastMessage }, ...replacement];
        const filterDummy = replaceResponse
          ? dummy.filter((d) => d._id != replaceResponse._id)
          : dummy;
        order = filterDummy.map((m) => m.modelRef);
        replaceMessage([...filterDummy], position);
      }

      setChat({
        ...selectedChat?.chat,
      });

      setLoading(true);
      loadingResponse.current = true;

      setAutoScroll(true);

      const source = axios.CancelToken.source();
      setAxiosSource(source);

      const timeout = setTimeout(() => {
        if (!cancel) {
          source.cancel();
          toast.error('The chat is taking too long to respond, try again.');
          setLoading(false);
          loadingResponse.current = false;
          setAxiosSource(null);
        }
      }, 4500 * 60);

      let currentLocalModels = JSON.parse(
        localStorage.getItem('currentModels')
      );

      const response = await store.api.post(
        `/ai/chat/attach`,
        {
          message: messages[position + 1].data.content,
          hash: selectedChat?.chat?._id,
          date: date,
          files: refFile ? refFile : null,
          idModels: uniqueNewModels.map((model) => model._id),
          replaceResponse: replaceResponse ? replaceResponse : null,
          coins: calculateCoins(
            getChatWords(messages[position + 1].data.content)
          ),
          source: 'web',
          version: import.meta.env.VITE_WEB_VERSION,
        },
        { cancelToken: source.token }
      );

      clearTimeout(timeout);
      loadingResponse.current = false;

      if (!response.data.success) {
        if (
          response.data.error === 'no_coins' ||
          response.data.error === 'missing_coins'
        ) {
          toastReward({
            title: 'Missing coins',
            message: 'Recharge your account on the profile page',
            linkText: "It's quick and easy. Click here!",
            linkUrl: '/my-profile/pricing',
            image: '/coin.gif',
            time: 10000,
          });
        } else {
          toast.error(response.data.error);
        }
      } else {
        setChatUrlValue(response.data.hash);

        const currentChat = selectedChat;
        const obj = {
          ...currentChat?.chat,
          _id: response.data.hash,
          title: response.data.title,
        };
        const responses = response.data.message;
        replaceMessage(
          Array.isArray(responses)
            ? order
              .map((id) => responses.find((r) => r.modelRef == id))
              .filter(Boolean)
            : { ...responses },
          position
        );
        setChat(obj);

        if (obj.messages.length) {
          countTotalWords(obj.messages);
        }

        userMessage.current = null;
        setParams({});
        setBehaviours([]);
        setAttrs({});
        setCurrentPrompt(null);
        updateDummyMessage(currentLocalModels);

        const lastMsg = messages[0];
        if (Array.isArray(lastMsg) && lastModel.current) {
          const modelId = lastMsg.filter(
            (m) => m.modelRef == lastModel.current
          );
          if (modelId.length > 0) {
            await selectedOutput(modelId[0]._id);
            lastModel.current = modelId[0].modelRef;
          }
        }
      }
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast(error?.response?.data?.error?.message, {
          icon: '⚠️',
        });
      }

      if (!stopped.current) {
        setChat({
          ...selectedChat?.chat,
        });
        setMessages((prev) => [...(prev ?? []).filter((m) => m.date != date)]);
      } else {
        setLoading(true);
        loadingResponse.current = true;
        await store.refreshTokenAndProfileCoins();
        await getChat(selectedChat.chat._id);
        setLoading(false);
        loadingResponse.current = false;
      }

      console.error(error);
    } finally {
      setLoading(false);
      loadingResponse.current = false;
      setAddResponseModels(false);
      setReplaceResponse(null);
      goToDown();
      setAxiosSource(null);
    }
  };

  const additionalConfig = async (lastMessage) => {
    if (!lastMessage.additional_config) {
      return;
    }

    let { attr, params, behaviours } = lastMessage.additional_config;
    let userMessage = messages[0];
    let tool = (await getPromptsByTool(userMessage.tool))[0];
    setCurrentPrompt(tool);
    setAttrs(attr);
    setParams(params);
    setBehaviours(behaviours);
  };

  // on regenerate message
  const onRegenerate = async () => {
    onCloseBoth();
    updateDummyMessage(selectedModels);
    const date = moment().utc();
    stopped.current = false;
    try {
      let lastMessage = messages.shift();
      await additionalConfig(lastMessage);
      setChat({
        ...selectedChat?.chat,
      });

      setLoading(true);
      loadingResponse.current = true;

      setAutoScroll(true);

      const source = axios.CancelToken.source();
      setAxiosSource(source);

      const timeout = setTimeout(() => {
        if (!cancel) {
          source.cancel();
          toast.error('The chat is taking too long to respond, try again.');
          setLoading(false);
          loadingResponse.current = false;
          setAxiosSource(null);
        }
      }, 4500 * 60);

      let currentLocalModels = JSON.parse(
        localStorage.getItem('currentModels')
      );
      const endpoint =
        store.profile.pricing_method === 'perMessage'
          ? '/ai/chatRAG/regenerate'
          : '/ai/chat/regenerate';
      setStreamingMessage(createDummyMessage(currentLocalModels));

      const hash = parseQueryString(window.location.search)?.chat;
      const response = await store.api.post(
        endpoint,
        {
          message: messages[0].data.content,
          hash: hash,
          date: date,
          files: refFile ? refFile : null,
          idModel: currentLocalModels.map((model) => model._id),
          coins: calculateCoins(getChatWords(messages[0].data.content)),
          source: 'web',
          version: import.meta.env.VITE_WEB_VERSION,
        },
        { cancelToken: source.token }
      );

      clearTimeout(timeout);
      loadingResponse.current = false;

      if (!response.data.success) {
        if (
          response.data.error === 'no_coins' ||
          response.data.error === 'missing_coins'
        ) {
          toastReward({
            title: 'Missing coins',
            message: 'Recharge your account on the profile page',
            linkText: "It's quick and easy. Click here!",
            linkUrl: '/my-profile/pricing',
            image: '/gifs/coin.gif',
            time: 10000,
          });
        } else {
          toast.error(response.data.error);
        }
      } else {
        setChatUrlValue(response.data.hash);

        const currentChat = selectedChat;
        const obj = {
          ...currentChat?.chat,
          _id: response.data.hash,
          title: response.data.title,
        };
        setChat(obj);
        replaceFirstMessage(response.data.message);

        if (obj.messages.length) {
          countTotalWords(obj.messages);
        }

        userMessage.current = null;
        setParams({});
        setBehaviours([]);
        setAttrs({});
        setCurrentPrompt(null);

        const lastMsg = obj.messages[0];
        if (Array.isArray(lastMsg) && lastModel.current) {
          const modelId = lastMsg.filter(
            (m) => m.modelRef == lastModel.current
          );
          if (modelId.length > 0) {
            await selectedOutput(modelId[0]._id);
            lastModel.current = modelId[0].modelRef;
          }
        }
      }
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast(error?.response?.data?.error?.message, {
          icon: '⚠️',
        });
      }

      if (!stopped.current) {
        setChat({
          ...selectedChat?.chat,
        });
        setMessages((prev) => [...(prev ?? []).filter((m) => m.date != date)]);
      } else {
        setLoading(true);
        loadingResponse.current = true;
        await store.refreshTokenAndProfileCoins();
        await getChat(selectedChat.chat._id);
        setLoading(false);
        loadingResponse.current = false;
      }

      console.error(error);
    } finally {
      setLoading(false);
      loadingResponse.current = false;
      goToDown();
      setAxiosSource(null);
    }
  };

  // Only when a message is edited
  const calculateCoinsEdit = (words, imagesPreviewEdit) => {
    let totalCoins = 0;
    const currentEditModels = JSON.parse(localStorage.getItem('currentModels'));
    currentEditModels.forEach((model) => {
      const pricing = model.pricing;
      const input = words > model.words_text ? model.words_text : words;
      let imagesCost = 0;
      if (model.type == 'vision') {
        for (let img of imagesPreviewEdit) {
          imagesCost += img.image_url.words;
        }
      }
      const coins =
        (pricing.words > 0 ? (input + imagesCost) / pricing.words : 0) *
        pricing.coins;

      totalCoins += currentPrompt
        ? parseFloat(handleBehaviour(coins))
        : parseFloat(coins.toFixed(2));
    });

    return totalCoins.toFixed(2);
  };

  // Only when a message is edited
  const additionalConfigEdit = async (aiResponse, userMessage) => {
    if (!aiResponse.additional_config) {
      return;
    }

    let { attr, params, behaviours } = aiResponse.additional_config;
    let tool = (await getPromptsByTool(userMessage.tool))[0];
    setCurrentPrompt(tool);
    setAttrs(attr);
    setParams(params);
    setBehaviours(behaviours);
  };

  // Function to edit a message prompt
  const onRegenerateEdit = async (
    editText,
    datePrompt,
    currentEditChat,
    imagesEdit,
    countWordsEdit,
    previousChat,
    undoOptimization
  ) => {
    onCloseBoth();
    goToDown();
    const date = moment().utc();
    stopped.current = false;

    let originalPrompt = null;
    let LLMRole = '';
    let displayedPrompt = false;
    let basePrompt = '';
    let systemInstructions = '';

    try {
      let selectedMessage = currentEditChat.messages.find(
        (message) => message.date === datePrompt
      );

      let selectedMessageIndex = currentEditChat.messages.findIndex(
        (message) => message.date === datePrompt
      );
      let aiIndexResponse = selectedMessageIndex - 1;

      let aiResponse = currentEditChat.messages[aiIndexResponse];

      await additionalConfigEdit(aiResponse, selectedMessage);

      setLoading(true);
      loadingResponse.current = true;

      if (
        smartMode === 'on' &&
        !isTemplatePrompt &&
        editText &&
        !undoOptimization
      ) {
        originalPrompt = editText;
        displayedPrompt = true;
      }

      if (displayedPrompt) {
        setOptimizing(true);
        isProcessing.current = true;
        try {
          const optimizationResult = await optimizePrompt(originalPrompt);
          editText = optimizationResult.optimizedPrompt;
          LLMRole = optimizationResult.LLMRole;
          basePrompt = optimizationResult.basePrompt;
          systemInstructions = optimizationResult.systemInstructions;
        } finally {
          setOptimizing(false);
          isProcessing.current = false;
        }
      }

      const source = axios.CancelToken.source();
      setAxiosSource(source);

      const timeout = setTimeout(() => {
        if (!cancel) {
          source.cancel();
          toast.error('The chat is taking too long to respond, try again.');
          setLoading(false);
          loadingResponse.current = false;
          setAxiosSource(null);
        }
      }, 4500 * 60);

      let currentLocalModels = JSON.parse(
        localStorage.getItem('currentModels')
      );

      currentEditChat.messages = currentEditChat.messages.slice(
        aiIndexResponse + 1
      );

      if (Array.isArray(currentEditChat.messages[0].data.content)) {
        currentEditChat.messages[0].data.content = [];
        currentEditChat.messages[0].data.content.push(...imagesEdit);
        currentEditChat.messages[0].data.content.push({
          type: 'text',
          text: editText,
        });
      } else {
        currentEditChat.messages[0].data.content = editText;
      }

      currentEditChat.messages[0].date = new Date(date);
      currentEditChat.messages[0].data.originalPrompt = originalPrompt;
      currentEditChat.messages[0].data.LLMRole = LLMRole;
      currentEditChat.messages[0].data.basePrompt = basePrompt;
      currentEditChat.messages[0].data.systemInstructions = systemInstructions;
      currentEditChat.messages[0].data.originalPrompt = originalPrompt;
      currentEditChat.messages[0].data.LLMRole = LLMRole;
      setChat({ ...currentEditChat });
      setMessages([...currentEditChat.messages]);

      const endpoint =
        store.profile.pricing_method === 'perMessage'
          ? '/ai/chatRAG/editmessage'
          : '/ai/chat/editmessage';

      const response = await store.api.post(
        endpoint,
        {
          coins: calculateCoinsEdit(countWordsEdit, imagesEdit),
          hash: currentEditChat._id,
          files: refFile ? refFile : null,
          idModel: currentLocalModels.map((model) => model._id),
          messageEdited: editText,
          originalPrompt: originalPrompt,
          LLMRole: LLMRole,
          basePrompt: basePrompt,
          systemInstructions: systemInstructions,
          date: date,
          imagesEdit: imagesEdit,
          capabilities: capabilities.map((capability) => capability._id),
          datePrompt: datePrompt,
          source: 'web',
          version: import.meta.env.VITE_WEB_VERSION,
        },
        { cancelToken: source.token }
      );

      clearTimeout(timeout);
      loadingResponse.current = false;

      if (!response.data.success) {
        if (
          response.data.error === 'no_coins' ||
          response.data.error === 'missing_coins'
        ) {
          setChat({ ...previousChat });
          toastReward({
            title: 'Missing coins',
            message: 'Recharge your account on the profile page',
            linkText: "It's quick and easy. Click here!",
            linkUrl: '/my-profile/pricing',
            image: '/gifs/coin.gif',
            time: 10000,
          });
        } else {
          toast.error(response.data.error);
        }
      } else {
        setChatUrlValue(response.data.hash);

        const currentChat = selectedChat;
        const obj = {
          ...currentChat?.chat,
          _id: response.data.hash,
          title: response.data.title,
          messages: [
            Array.isArray(response.data.message)
              ? [...response.data.message]
              : { ...response.data.message },
            ...(currentChat?.chat?.messages ?? []),
          ],
        };
        setChat(obj);
        setMessages([...obj.messages]);

        if (obj.messages.length) {
          countTotalWords(obj.messages);
        }

        userMessage.current = null;
        setParams({});
        setBehaviours([]);
        setAttrs({});
        setCurrentPrompt(null);
        updateDummyMessage(selectedModels);

        const lastMsg = obj.messages[0];
        if (Array.isArray(lastMsg) && lastModel.current) {
          const modelId = lastMsg.filter(
            (m) => m.modelRef == lastModel.current
          );
          if (modelId.length > 0) {
            await selectedOutput(modelId[0]._id);
            lastModel.current = modelId[0].modelRef;
          }
        }
      }
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast(error?.response?.data?.error?.message, {
          icon: '⚠️',
        });
      }

      if (!stopped.current) {
        setChat({
          ...selectedChat?.chat,
          messages: [...(messages ?? []).filter((m) => m.date != date)],
        });
        setMessages((prev) => [...(prev ?? []).filter((m) => m.date != date)]);
        setMessages([...currentEditChat.messages]);
      } else {
        setLoading(true);
        loadingResponse.current = true;
        await store.refreshTokenAndProfileCoins();
        await getChat(selectedChat.chat._id);
        setLoading(false);
        loadingResponse.current = false;
      }

      console.error(error);
    } finally {
      setLoading(false);
      loadingResponse.current = false;
      setAxiosSource(null);
    }
  };

  const visionInput = (textValue = undefined) => {
    const imagesMessages = [];
    for (let image of imagesPreview) {
      imagesMessages.push({
        type: 'image_url',
        image_url: { url: image.url, words: image.words },
      });
    }
    return [
      ...imagesMessages,
      { type: 'text', text: textValue ? textValue : inputValue },
    ];
  };

  /**
   * This is the logic to manage the shared tools
   */
  useTemplateShare(store.api, openModalTemplate, getToolsAndFilterSidebar);
  // ---------------------------------------------------

  useEffect(() => {
    getToolsAndFilterSidebar('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ----------------------------
  //  Modals functions
  // ----------------------------
  const onDelete = async () => {
    const arrCopy = Array.from(chatList);
    const objWithIdIndex = arrCopy.findIndex((obj) => obj._id === toDelete);
    arrCopy.splice(objWithIdIndex, 1);
    try {
      removeChatUrlValue();
      await store.api.delete('/chat/' + toDelete);
      cleanSelectedChat();
      setChat({ _id: null, messages: [] });
      setTreeData(treeData.filter((item) => item.id !== selectedChat.chat._id));
      setChatsList(arrCopy);

      dummy.current = { _id: null, messages: [] };
    } catch (error) {
      console.error(error);
    } finally {
      onNewChat();
      setToDeleteDND(null);
      setShowDeleteDialog(false);
      setDeleted(true);
      setToDelete(null);
    }
  };

  const onClear = async () => {
    try {
      const messageIds = messages.flatMap((message) =>
        Array.isArray(message)
          ? message.map((msg) => msg._id).filter((id) => id !== undefined)
          : message._id !== undefined
            ? [message._id]
            : []
      );

      const visibleMessages = messages
        .flatMap((message) => (Array.isArray(message) ? message : [message]))
        .filter((msg) => !msg.hidden);

      if (loading) {
        toast('Wait a moment, the chat is being processed', {
          icon: '📢',
        });
        return;
      } else if (visibleMessages.length === 0) {
        toast.error('No valid messages found to delete.');
        return;
      }

      const deletePromises = messageIds.map((messageId) =>
        store.api.delete(`/chat/${selectedChat.chat._id}/${messageId}`)
      );

      const responses = await Promise.all(deletePromises);

      const allSuccess = responses.every((response) => response.data.success);

      if (allSuccess) {
        const updatedMessages = messages.map((message) =>
          Array.isArray(message)
            ? message.map((msg) => ({ ...msg, hidden: true }))
            : { ...message, hidden: true }
        );

        await store.api
          .delete(`/chat/${selectedChat.chat._id}/title`)
          .then(async () => {
            const chat = selectedChat.chat;

            const oldData = treeData.filter((item) => item.id !== chat._id);
            const selectedChatTree = treeData.find(
              (item) => item.id === chat._id
            );
            setTreeData([...oldData, { ...selectedChatTree, text: '' }]);
          });

        const updatedChat = {
          ...selectedChat.chat,
          messages: updatedMessages,
          title: '',
        };

        setSelectedChat(updatedChat);
        setMessages(updatedMessages);

        setTimeout(() => {
          toast.success('All messages have been cleared.');
        }, 2000);
      } else {
        toast.error('Failed to clear the chat.');
      }
    } catch (error) {
      console.error('Error clearing messages:', error);
      toast.error('Error clearing messages.');
    } finally {
      setShowClearDialog(false);
      setCleared(true);
    }
  };

  const onDownloadChat = async (chatId) => {
    try {
      const response = await store.api.get(`/chat/${chatId}`);
      const chatData = response.data.chat;
      chatData.messages.reverse();

      const formattedChatData = formatChatDataForTxt(chatData);
      const cleanedChatTitle = chatData.title
        .replace(/[/\\?%*:|"<>]/g, '-')
        .replace(/\s+/g, '_')
        .trim();

      downloadTxtFile(formattedChatData, `chat-${cleanedChatTitle}.txt`);
    } catch (error) {
      console.error('Error downloading chat:', error);
      if (error?.response?.status === 500) {
        toast(
          'Chat could not be downloaded. Please wait for the first message to completely load before attempting to download.',
          {
            icon: '✖️',
          }
        );
      }
    }
  };

  const onDownloadChatPDF = async (chatId) => {
    try {
      const response = await store.api.get(`/chat/${chatId}`);
      const chatData = response.data.chat;
      chatData.messages.reverse();

      const cleanedChatTitle = chatData.title
        .replace(/[/\\?%*:|"<>]/g, '-')
        .replace(/\s+/g, '_')
        .trim();

      generatePDF(chatData, cleanedChatTitle);
    } catch (error) {
      console.error('Error generating PDF:', error);
      if (error?.response?.status === 500) {
        toast(
          'Chat could not be downloaded. Please wait for the first message to completely load before attempting to download.',
          {
            icon: '✖️',
          }
        );
      }
    }
  };

  const onEdit = (e) => {
    if (e.title) {
      const arrCopy = Array.from(chatList);
      const objWithIdIndex = arrCopy.findIndex(
        (obj) => obj._id === selectedChat?.chat?._id
      );
      const copyData = {
        ...arrCopy[objWithIdIndex],
        title: e.title,
      };

      setChatsList(copyData);
      setChat({ ...selectedChat?.chat, title: e.title });
    }
    setShowEditDialog(false);
  };
  // ----------------------------
  // Debounce
  const debouncedValueText = useDebounce(inputValue, 200);

  /**
   * Template chat list logic
   */
  useMenuActionsTextFieldLogic(
    store,
    debouncedValueText,
    promptListRef,
    renderType,
    setRenderType,
    setOpenMenuAction,
    TABS,
    ROWS,
    isMobile,
    setShowMobileChats
  );

  // handle key press events and IME composition
  const [isComposing, setIsComposing] = useState(false);

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = () => {
    setIsComposing(false);
  };

  const visibleOptions = useMemo(
    () => filteredOptions?.filter((option) => !option.isHidden),
    [filteredOptions]
  );

  const onEnterPress = useCallback(
    (e) => {
      if (isComposing) return;
      const totalItemsMenuAction =
        visibleOptions.length + templatesChatList.length;
      if (openMenuAction) {
        switch (e.key) {
          case 'ArrowDown':
          case 'Tab':
            e.preventDefault();
            setActivePromptIndex((prevIndex) => {
              const newIndex = prevIndex + 1;
              const shouldReset = newIndex >= totalItemsMenuAction - 1;
              currentIndexMenuAction.current = shouldReset ? 0 : newIndex;
              return shouldReset ? 0 : newIndex;
            });
            break;
          case 'ArrowUp':
            e.preventDefault();
            setActivePromptIndex((prevIndex) => {
              const newIndex = prevIndex - 1;
              const shouldReset = newIndex <= 0;
              currentIndexMenuAction.current = shouldReset ? 0 : newIndex;
              return shouldReset ? 0 : newIndex;
            });
            break;
          case 'Enter':
            e.preventDefault();
            handleKeyDownEnter();
            setOpenMenuAction(false);
            break;
          case 'Escape':
            e.preventDefault();
            setOpenMenuAction(false);
            break;
          default:
            setActivePromptIndex(0);
            break;
        }
      } else if (!isMobile && e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        setCancel(false);
        onSend();
      }
    },
    [templatesChatList, visibleOptions, isComposing, isMobile, openMenuAction]
  );

  // handleSendPrompt
  const { focus } = useTextAreaFocus();
  const checkTemplateModel = async (
    updatedVariables,
    templateData,
    files,
    runSampleAuto
  ) => {
    // Send fields context to the chat
    if (files.length > 0) await addReferenceFile(files);
    toolData.current = { updatedVariables, templateData };

    let isSelected = false;

    if (templateData) {
      if (templateData.use_tool) {
        isSelected = true;
      } else if (templateData.multi_default_models.length > 0) {
        isSelected = templateData.multi_default_models?.every((model) =>
          selectedModels.some(
            (selectedModel) => model._id === selectedModel._id
          )
        );
      } else if (templateData.default_model) {
        isSelected = selectedModels.every(
          (m) => m._id == templateData.default_model._id
        );
      }
    }

    if (isSelected) {
      handleSubmitModal(
        updatedVariables,
        templateData,
        templateData.useTool ? false : true,
        runSampleAuto,
        files
      );
    } else {
      setShowWarningDialog(true);
      setRunSampleAutoFlag(runSampleAuto);
    }
  };

  const handleSubmitModal = (
    updatedVariables,
    templateData,
    useTemplateModels,
    runSampleAuto = false,
    files
  ) => {
    setShowWarningDialog(false);
    toolData.current = null;

    const models =
      useTemplateModels && currentTemplateModels?.length > 0
        ? currentTemplateModels
        : selectedModels;
    setSelectedModels(models);

    let newContent =
      templateData && templateData.use_tool
        ? templateData.prompt_values.label
        : templateData.prompt_values.value;

    setInputValue('');
    setParams({});
    setBehaviours([]);
    setAttrs({});
    setCurrentPrompt(templateData.prompt_values);

    updatedVariables.forEach(([key, value]) => {
      const attrs = templateData.prompt_values.attr.filter((item) =>
        typeof item == 'object' ? item.name == key : item == key
      );

      if (attrs.length > 0) {
        const attr = attrs[0];

        if (typeof attr == 'object' && attr.config) {
          switch (attr.config) {
            case 'param':
              setParams((prev) => ({ ...prev, [key]: value }));
              break;
            case 'attr':
              setAttrs((prev) => ({ ...prev, [key]: value }));
              break;
            default:
              break;
          }
        }

        if (typeof attr == 'object' && attr.behaviour) {
          setBehaviours((prev) => [...prev, { target: key, value: value }]);
        }
      }

      if (typeof value !== 'object' && value !== '' && value) {
        newContent = newContent?.replaceAll(
          '${' + key + '}',
          `"'${value.trim()}'"`
        );
      }
    });

    setInputValue(newContent);
    focus();
    // This line sends the values to track the prompt usages
    setValuesAfterInsert(templateData.prompt_values, templateData);
    if (runSampleAuto) {
      let modelsIds = models.map((m) => m._id);
      onSend(null, newContent, modelsIds, files);
    }
    setRunSampleAutoFlag(false);
  };

  // handleCloseTemplateModal
  const handleCloseTemplateModal = (defaultParams) => {
    // remove the states
    setTemplateData(null);
    setSelectedPrompt(null);
    setActivePromptIndex(null);
    toggleShowPromptModal();

    // Create params
    const params = new URLSearchParams(location.search);
    params.delete('selectedTool');

    // delete the params
    if (defaultParams) {
      Object.entries(defaultParams).forEach(([key]) => {
        params.delete(key);
      });
    }

    // remove the selected tool from the url
    navigate(
      {
        pathname: location.pathname,
        search: params.toString(),
      },
      { shallow: true }
    );
    addEvent(LOADING_FAV_TOOLS);
  };

  const { showCreateTemplateDialog, setCreateTemplateModalOpen } =
    useCreateTemplatesStore((state) => ({
      showCreateTemplateDialog: state.showCreateTemplateDialog,
      setCreateTemplateModalOpen: state.setCreateTemplateModalOpen,
    }));

  const handleCreateTemplate = () => {
    setCreateTemplateModalOpen(true);
  };

  //Model by template default model
  const handleTemplateModel = async (modelsId) => {
    if (modelsId && modelsId.length > 0) {
      const queryString = modelsId
        .map((modelId) => `default_model_template=${modelId}`)
        .join('&');
      try {
        const response = await store.api.get(`/model/byId?${queryString}`);
        setCurrentTemplateModels(response.data.model);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const functionMap = visibleOptions.reduce((acc, option, idx) => {
    let actualIndex = idx;
    acc[actualIndex] = (() => {
      if (option.name === 'New Chat') {
        return onNewChat;
      } else if (option.name === 'Select Model') {
        return () => setShowModelsDialog(true);
      } else if (option.name === 'Text To Speech') {
        return () => handleScriptForTTS([]);
      } else if (option.name === 'Clear Chat') {
        return () => setShowClearDialog(true);
      } else if (option.name === 'Create Template') {
        return () => setCreateTemplateModalOpenMenuAction(true);
      } else {
        return handleShowMobilePrompts;
      }
    })();
    return acc;
  }, {});

  // handle init modal
  const handleKeyDownEnter = () => {
    if (activePromptIndex == null || activePromptIndex === -1) {
      return;
    }
    // Execute the function of actions
    if (activePromptIndex in functionMap) {
      functionMap[currentIndexMenuAction.current]();
      // Execute the function of the templates
    } else {
      const templateIndex = currentIndexMenuAction.current - visibleOptions.length;
      const selectedToolLocal = templatesChatList[templateIndex];
      const params = new URLSearchParams(location.search);
      params.set('selectedTool', selectedToolLocal._id);
      // add the selected tool to the url
      navigate(
        {
          pathname: location.pathname,
          search: params.toString(),
        },
        { shallow: true }
      );
      // Close the menu
      setOpenMenuAction(false);
    }
  };

  const onCloseBoth = () => {
    setShowMobileChats(false);
    setShowMobilePrompts(false);
  };

  // create new chat
  onNewChat = async () => {
    const { selectedModels } = useChatStore.getState();
    const sortedModels = selectedModels.sort((a, b) =>
      a.abbreviation.localeCompare(b.abbreviation)
    );
    localStorage.setItem('currentModels', JSON.stringify(sortedModels));
    setInputValue('');
    lastModel.current = null;
    loadingResponse.current = false;
    clearMessages();
    cancelChat();
    setChat({ _id: null, messages: [] });
    setChatWords(0);
    removeChatUrlValue();
    userMessage.current = null;
    setShowMobileChats(false);
    setShowMobilePrompts(false);
    dummy.current = { _id: null, messages: [] };
    cleanSelectedChat();
    focus();
    setRefFile(null);
    setStraicoChoiceTools(straicoChoiceTools);
    checkUseTool();
  };

  const checkUseTool = () => {
    if (!currentPrompt) {
      return;
    }

    let tool;
    const filtered = tools.filter((item) => item._id == currentPrompt.tool);

    if (filtered && filtered.length > 0) {
      tool = filtered[0];
    }

    if (tool && tool.useTool) {
      setInputValue('');
      setParams({});
      setBehaviours([]);
      setAttrs({});
      setCurrentPrompt(null);
    }
  };

  // on select chat
  const onSelectChat = (chat, messageIdentifier = null, isUser = null) => {
    cancelChat();
    // Rest methods
    userMessage.current = null;
    clearMessages();
    setXchatId(chat?._id);
    getChat(chat?._id, messageIdentifier, isUser);
    setShowMobileChats(false);
    setRefFile(null);
    checkUseTool();
    // Stop the stream current chat
    if (loadingResponse.current) {
      store.stopStreamChat(
        selectedChat?.chat._id ? selectedChat?.chat._id : chatId.current
      );
    }
    loadingResponse.current = false;
  };

  // If the input value is empty, clean the latest fields
  useEffect(() => {
    if (inputValue === '') {
      cleanLastestFields();
      if (!loading) {
        setParams({});
        setBehaviours([]);
        setAttrs({});
        setCurrentPrompt(null);
      }
    }
  }, [inputValue]);

  const addReferenceFile = async (files) => {
    setLoadingBar(true);
    //TODO to send the multi extensions files
    if (
      refFile &&
      Array.isArray(refFile) &&
      refFile.length > 0 &&
      Array.isArray(files) &&
      files.length > 0
    ) {
      for (let i = 0; i < files.length; i++) {
        const attachment = files[i];
        let searchFile = refFile.find(
          (file) => file.metadata.name === attachment.name
        );

        if (searchFile) {
          // File with the same name already exists
          const fileExtension = attachment.name.split('.').pop().toLowerCase();
          const fileNameWithoutExtension = attachment.name
            .substring(0, attachment.name.lastIndexOf('.'))
            .replace(/\s+/g, '_');
          const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
          attachment.name = `${fileNameWithoutExtension}_${timestamp}.${fileExtension}`;
          toast.custom((t) => (
            <CustomToastIcon
              id={t.id}
              message={`You already uploaded a file with the name ${searchFile.metadata.name}`}
              icon={<span style={{ fontSize: '16px' }}>😱</span>}
            />
          ));
        }
      }
    }

    for (let i = 0; i < files.length; i++) {
      let e = files[i].metadata ? files[i].metadata : files[i];
      try {
        setShowFileDialog(false);
        let response;

        if (typeof e === 'string') {
          const youtubeUrlPattern =
            /^(https?:\/\/)?(www\.)?(m\.)?(youtube\.com|youtu\.be)\/.+/i;
          if (youtubeUrlPattern.test(e)) {
            // Upload YouTube video first time
            toast('The upload process can take some seconds. Please wait.', {
              icon: '⌛️',
            });
            response = await store.api.post(`/file/youtube`, {
              url: e,
              enabled: true,
            });
          } else {
            // Upload Web page first time
            response = await store.api.post(`/file/webpage`, {
              url: e,
              enabled: true,
            });
            if (response.data.file.words <= 10) {
              toast(
                'This web page has additional technology that unables us to access its content',
                {
                  icon: '⛔️',
                }
              );
              continue;
            }
          }
        } else if (
          e.type == 'md' ||
          e.type == 'text/markdown' ||
          e.name.endsWith('.md')
        ) {
          // e.type == 'md' || e.type == 'text/markdown' || e.name.endsWith('.md')
          response = await store.api.post(`/file`, e);
        } else if (e.type == 'pdf' || e.type == 'application/pdf') {
          e.type = 'pdf';
          // Load previous pdf
          response = await store.api.post(`/file`, e);
          if (response.data.file.words === 0) {
            toast(
              `The PDF (${e.name}) you are inserting is empty or couldn't be read`,
              {
                icon: '⛔️',
              }
            );
            continue;
          }
        } else if (e.type == 'image') {
          // Load images allways
          response = await store.api.post(`/file`, e);
        } else if (e.type == 'youtube') {
          // Load previos youtube
          response = await store.api.post(`/file/youtube`, e);
        } else if (e.type == 'webpage') {
          // Load previos webpage
          response = await store.api.post(`/file/webpage`, e);
          if (response.data.file.words <= 10) {
            toast(
              'This web page has additional technology that unables us to access its content',
              {
                icon: '⛔️',
              }
            );
            continue;
          }
        } else if (
          e.type ===
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          e.type === 'docx'
        ) {
          e.type = 'docx';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type ===
          'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
          e.type === 'pptx'
        ) {
          e.type = 'pptx';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          e.type === 'xlsx'
        ) {
          toast(
            'When querying an Excel Document file, formulas nor macros will be taken into account',
            {
              icon: '👀',
              duration: 12000, // 12 seconds in milliseconds
            }
          );
          e.type = 'xlsx';
          response = await store.api.post(`/file`, e);
        } else if (e.type === 'text/plain' || e.type === 'txt') {
          e.type = 'txt';
          response = await store.api.post(`/file`, e);
        } else if (e.type === 'text/html' || e.type === 'html') {
          e.type = 'html';
          response = await store.api.post(`/file`, e);
        } else if (e.type === 'application/json' || e.type === 'json') {
          e.type = 'json';
          response = await store.api.post(`/file`, e);
        } else if (e.type === 'text/csv' || e.type === 'csv') {
          e.type = 'csv';
          response = await store.api.post(`/file`, e);
        } else if (e.type === 'audio/mpeg' || e.type === 'mp3') {
          e.type = 'mp3';
          response = await store.api.post(`/file/multimedia`, e);
        } else if (e.type === 'video/mp4' || e.type == 'mp4') {
          if (!('words' in e)) {
            toast('The upload process can take several minutes. Please wait.', {
              icon: '⌛️',
            });
          }

          e.type = 'mp4';
          response = await store.api.post(`/file/multimedia`, e);
          //SC: New file extensions
        } else if (
          e.type === 'text/x-python' ||
          e.type === 'py' ||
          e.name.endsWith('.py')
        ) {
          e.type = 'py';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type === 'text/x-php' ||
          e.type === 'php' ||
          e.name.endsWith('.php')
        ) {
          e.type = 'php';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type === 'application/javascript' ||
          e.type === 'text/javascript' ||
          e.type === 'js' ||
          e.name.endsWith('.js')
        ) {
          e.type = 'js';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type === 'text/css' ||
          e.type === 'css' ||
          e.name.endsWith('.css')
        ) {
          e.type = 'css';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type === 'text/x-csharp' ||
          e.type === 'cs' ||
          e.name.endsWith('.cs')
        ) {
          e.type = 'cs';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type === 'text/x-swift' ||
          e.type === 'swift' ||
          e.name.endsWith('.swift')
        ) {
          e.type = 'swift';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type === 'text/x-kotlin' ||
          e.type === 'kt' ||
          e.name.endsWith('.kt')
        ) {
          e.type = 'kt';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type === 'application/xml' ||
          e.type === 'text/xml' ||
          e.type === 'xml' ||
          e.name.endsWith('.xml')
        ) {
          e.type = 'xml';
          response = await store.api.post(`/file`, e);
        } else if (
          e.type === 'application/typescript' ||
          e.type === 'ts' ||
          e.name.endsWith('.ts')
        ) {
          e.type = 'ts';
          response = await store.api.post(`/file`, e);
        } else {
          response = await store.api.post(`/file`, e);
        }

        if (e.type == 'image') {
          setImagesPreview((prevImagesPreview) => {
            if (Array.isArray(prevImagesPreview)) {
              if (
                !prevImagesPreview.some((file) => file === response.data.file)
              ) {
                // If it's not in the array, add the new file to it
                return [...prevImagesPreview, response.data.file];
              } else {
                // If it's already in the array, return the current array
                return prevImagesPreview;
              }
            } else {
              // If it's not an array, create a new array with the current and new file
              let newarray = [response.data.file];
              return newarray;
            }
          });
        } else {
          // setRefFile(response.data.file);
          updateRefFile((prevRefFile) => {
            if (Array.isArray(prevRefFile)) {
              // Check if the file is already in the array
              if (
                !prevRefFile.some(
                  (file) => file.file === response.data.file._id
                )
              ) {
                // If it's not in the array, add the new file to it
                return [...prevRefFile, convertFile(response.data.file)];
              } else {
                // If it's already in the array, return the current array
                return prevRefFile;
              }
            } else {
              // If it's not an array, create a new array with the current and new file
              let newarray = [convertFile(response.data.file)];
              return newarray;
            }
          });
          toast.custom((t) => (
            <CustomSuccessToast
              id={t.id}
              message={`The file ${e.name ? 'named ' + e.name : ''
                } is attached.`}
            />
          ));
        }
      } catch (error) {
        if (error?.response?.data?.error?.message) {
          toast.error(error?.response?.data?.error?.message);
        }
      } finally {
        if (i === files.length - 1) setLoadingBar(false);
      }
    }
  };

  const convertFile = (file) => {
    return { file: file._id, enabled: true, metadata: { ...file } };
  };

  // -------------------------------------
  // TTS
  // -------------------------------------
  const handleScriptForTTS = (value = []) => {
    setScriptValue(value);
    setShowTextSpeechDialog(true);
  };

  // -------------------------------------
  // Audio input
  // -------------------------------------
  const {
    startRecording,
    stopRecording,
    recordingBlob,
    isRecording,
    recordingTime,
  } = useAudioRecorder();

  const [isVoiceProcessing, setIsVoiceProcessing] = useState(false);

  useEffect(() => {
    if (!recordingBlob) return;
    getAudio(recordingBlob);
  }, [recordingBlob]);

  const getAudio = async (blob) => {
    setLoadingBar(true);
    setIsVoiceProcessing(true);
    const data = new FormData();
    data.append('file', blob, '2260c8a3-5c42-4a1b-8503-dedd931cc835.webm');
    try {
      const response = await store.api.post('/auth/whisper', data, {});
      const newText = response.data.text.trim();
      setInputValue((prevValue) => {
        const currentValue = prevValue.trim();
        return currentValue ? `${currentValue} ${newText}` : newText;
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingBar(false);
      setIsVoiceProcessing(false);
      toast('Your recording was successfully processed!', {
        icon: <InformationCircleIcon className="w-4 h-4 text-cool-gray" />,
      });
    }
  };

  // -------------------------------------

  const calculateCoins = (words) => {
    // If using Pricing per Message, calculate dynamic cost based on word count
    if (store.profile.pricing_method === 'perMessage') {
      let totalCoins = 0;

      // Define power multiplier constants
      const SCALE_FACTOR = 1000.0;
      const EXPONENT = 1.5954;
      const MAX_MULTIPLIER = parseFloat(
        import.meta.env.VITE_PPI_MULTIPLIER || 15
      );
      selectedModels.forEach((model) => {
        // Base price per interaction
        const basePrice = model.pricing.coins;

        // Add image costs if configured
        let imagePrice = 0;
        if (model.type === 'vision' && imagesPreview.length > 0) {
          imagePrice = imagesPreview.reduce((acc, img) => {
            return (
              acc +
              ((img.words || 0) / model.pricing.words) * model.pricing.coins
            );
          }, 0);
        }

        // Calculate multiplier based on word count using power function
        // formula: 1 + (wordCount/scale)**exponent * (max_mult-1)
        const dynamicMultiplier =
          1 + Math.pow(words / SCALE_FACTOR, EXPONENT) * (MAX_MULTIPLIER - 1);
        const cappedMultiplier = Math.min(dynamicMultiplier, MAX_MULTIPLIER);

        // Apply dynamic multiplier instead of fixed PPI_CONFIG.multiplier
        const finalPrice =
          basePrice * cappedMultiplier +
          (PPI_CONFIG.includeImageCost ? imagePrice : 0);

        totalCoins += currentPrompt
          ? parseFloat(handleBehaviour(finalPrice))
          : parseFloat(finalPrice.toFixed(2));
      });

      return totalCoins.toFixed(2);
    }

    // If using standard pricing (perWord)
    else {
      let totalCoins = 0;
      const wordcapLimits = store.profile.wordcap_limits;

      selectedModels.forEach((model) => {
        const pricing = model.pricing;
        let maxWords = wordcapLimits ? wordcapLimits.words : 0;

        if (maxWords === 0 || maxWords > tokensToWords(model.context_length)) {
          maxWords = Math.round(tokensToWords(model.context_length));
        }

        const input = words > maxWords ? maxWords : words;
        let imagesCost = 0;

        if (model.type === 'vision') {
          for (let img of imagesPreview) {
            imagesCost += img.words;
          }
        }

        const coins =
          (pricing.words > 0 ? (input + imagesCost) / pricing.words : 0) *
          pricing.coins;

        totalCoins += currentPrompt
          ? parseFloat(handleBehaviour(coins))
          : parseFloat(coins.toFixed(2));
      });

      return totalCoins.toFixed(2);
    }
  };
  // Related to the Pricing per Interaction method
  const getCostColorClass = (cost, theme) => {
    // Special case: no cost
    if (cost < 0.1) {
      return 'bg-[#464bba] text-white';
    }
    // Traffic Light Colors with new friendly colors
    else if (cost < 60) {
      return theme === 'dark'
        ? 'bg-[#9cb773] text-white'
        : 'bg-[#9cb773] text-white';
    } else if (cost < 200) {
      return theme === 'dark'
        ? 'bg-[#e3c06f] text-white'
        : 'bg-[#e3c06f] text-white';
    } else {
      return theme === 'dark'
        ? 'bg-[#e68e5b] text-white'
        : 'bg-[#e68e5b] text-white';
    }
  };
  const updatePricingMethod = async (method) => {
    try {
      // First, make the API call to update the user profile
      const res = await store.api.post(`/user/update-user`, {
        pricing_method: method,
      });

      if (res.status === 200) {
        // Update local storage and store after successful DB update
        store.profile.pricing_method = method;

        // Base toast configuration
        const newMode = method === 'perMessage';
        const svgIconBase64 = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAyNyAzNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjYuNSA4LjVIMTkuMjc3NkwyMy42MTA5IDBIMTIuMDU1OEwwLjUgMjIuNjY2NEg5LjE2NjY3VjM0TDI2LjUgOC41WiIgZmlsbD0iaW5oZXJpdCIvPjwvc3ZnPg==`;

        const customToastOptions = {
          style: {
            background: newMode ? '#FFEFE5' : '#E1E1E5',
            color: '#000',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            padding: '16px',
            display: 'flex',
            alignItems: 'center',
            width: window.innerWidth < 600 ? '100%' : 'auto',
            maxWidth: window.innerWidth < 600 ? '100%' : '30%',
            minWidth: window.innerWidth < 600 ? '100%' : '20%',
          },
          icon: (
            <img
              src={svgIconBase64}
              alt="Lightning Icon"
              width={window.innerWidth < 600 ? '20' : '24'}
              height={window.innerWidth < 600 ? '20' : '24'}
              style={{
                marginRight: '8px',
                filter: newMode
                  ? 'invert(34%) sepia(100%) saturate(1500%) hue-rotate(-14deg) brightness(180%) contrast(90%) opacity(70%)'
                  : 'invert(0%) sepia(0%) saturate(0%) hue-rotate(204deg) brightness(100%) contrast(10%)',
              }}
            />
          ),
          duration: 3000,
          position: window.innerWidth < 600 ? 'top-center' : 'top-right',
        };

        const titleStyle = {
          fontWeight: 700,
          fontSize: '16px',
          marginBottom: '4px',
          color: newMode ? '#F2A474' : '#575557',
          fontFamily: 'Figtree, sans-serif',
        };

        const subtitleStyle = {
          fontSize: '14px',
          color: '#6B6B6B',
        };

        // Show appropriate toast message
        if (newMode) {
          toast(
            <div>
              <div style={titleStyle}>Pricing per Message – Activated</div>
              <div style={subtitleStyle}>
                Fixed cost per message, regardless of length
              </div>
            </div>,
            customToastOptions
          );
        } else {
          toast(
            <div>
              <div style={titleStyle}>Pricing per Message – Deactivated</div>
              <div style={subtitleStyle}>
                Cost now varies based on conversation length
              </div>
            </div>,
            customToastOptions
          );
        }

        return true;
      } else {
        toast.error('Error updating pricing method');
        return false;
      }
    } catch (error) {
      console.error('Error updating pricing method:', error);
      toast.error('Error updating pricing method');
      return false;
    }
  };

  // Get the color class based on pricing method
  const getCostDisplayClass = () => {
    const cost = calculateCoins(getChatWords(inputValue));

    if (store.profile.pricing_method === 'perMessage') {
      return themeValue === 'dark'
        ? 'bg-[#464bba] text-white'
        : 'bg-[#464bba] text-white';
    }

    return checkLimit(inputValue)
      ? 'bg-red-600 text-white'
      : getCostColorClass(cost, themeValue);
  };

  const tokensToWords = (tokens) => {
    return (tokens * 3) / 4;
  };

  const handleBehaviour = (coins) => {
    let tool;
    const filtered = tools.filter((item) => item._id == currentPrompt.tool);

    if (filtered && filtered.length > 0) {
      tool = filtered[0];
    }

    if (!tool || (tool && !tool.useTool)) {
      return coins.toFixed(2);
    }

    const data = currentPrompt.attr.filter(
      (item) => typeof item == 'object' && item.behaviour
    );

    if (!data || data.length == 0) {
      return coins.toFixed(2);
    }

    let finalCoins = tool.coins;
    let clonedTool = JSON.parse(JSON.stringify(tool));
    for (let behaviour of data) {
      const behaviourData = behaviours.filter(
        (obj) => obj.target == behaviour.name
      )[0];
      switch (behaviour.behaviour) {
        case 'call_times': {
          finalCoins = clonedTool.coins * behaviourData.value;
          clonedTool.coins = finalCoins;
          break;
        }
        case 'price_adjustment': {
          const rule = behaviour.rules.filter(
            (item) => item.value == behaviourData.value
          )[0];
          finalCoins = rule ? clonedTool.coins * rule.factor : clonedTool.coins;
          clonedTool.coins = finalCoins;
          break;
        }
        default:
          break;
      }
    }

    return finalCoins.toFixed(2);
  };

  const handleBehaviourLoader = () => {
    if (!tools.length) {
      getToolsAndFilter('');
    }

    let tool = selectedTool;
    const filtered = !tool
      ? tools.filter((item) => item._id == currentPrompt.tool)
      : null;

    if (filtered && filtered.length > 0) {
      tool = filtered[0];
    }

    if (!tool || (tool && !tool.useTool)) {
      return null;
    }
    const data = currentPrompt.attr.filter(
      (item) =>
        typeof item == 'object' &&
        item.behaviour &&
        item.behaviour == 'call_times'
    );
    if (data) {
      const behaviourData = behaviours.filter(
        (obj) => obj.target == data[0].name
      )[0];
      return Array(Number(behaviourData.value)).fill({
        type: 'image_url',
        image_url: {
          url: 'https://prompt-rack.s3.amazonaws.com/images/1703813690569_straico_loading-vanilla.gif',
          words: 0,
        },
        no_actions: true,
        loading: true,
      });
    }
    return [
      {
        type: 'image_url',
        image_url: {
          url: 'https://prompt-rack.s3.amazonaws.com/images/1703813690569_straico_loading-vanilla.gif',
          words: 0,
        },
        no_actions: true,
        loading: true,
      },
    ];
  };

  const changeOutput = async (element) => {
    if (element._id && !loadingResponse.current) {
      await selectedOutput(element._id);
      countTotalWords(messages);

      // check last message
      const lastMessage = messages[0];
      if (
        Array.isArray(lastMessage) &&
        lastMessage.map((r) => r._id).includes(element._id)
      ) {
        lastModel.current = element.modelRef;
      }
    } else {
      lastModel.current = element.modelRef;
    }
  };

  const selectedOutput = async (hash) => {
    await store.api.post(`/chat/message/${hash}`, {
      chat: selectedChat.chat._id ? selectedChat.chat._id : chatId.current,
    });
    setEditMessChange();
  };

  const getVisibleModel = () => {
    let refId;
    if (lastModel.current) {
      refId = lastModel.current;
    } else {
      let lastMsg = (messages?.length ?? 0) > 0 ? messages[0] : null;
      if (lastMsg) {
        let filterd = Array.isArray(lastMsg)
          ? lastMsg.filter((m) => m.selected == true)
          : null;
        refId =
          filterd && filterd.length
            ? filterd[0].modelRef
              ? filterd[0].modelRef
              : null
            : lastMsg.modelRef
              ? lastMsg.modelRef
              : null;
      }
    }

    let filteredModels = refId
      ? selectedModels.filter((model) => model._id == refId)
      : null;
    return filteredModels && filteredModels.length
      ? filteredModels[0]
      : selectedModels[0];
  };

  const getChatWords = (text) => {
    // If using perMessage pricing, count words based on RAG approach
    if (store.profile.pricing_method === 'perMessage') {
      let total = 0;

      // Add current input text words
      total += store.countWords(text || '');

      if (messages && Array.isArray(messages)) {
        // Get only visible messages and calculate turn number
        const visibleMessages = messages.filter((msg) => !msg.hidden);
        const turnNumber = Math.ceil(visibleMessages.length / 2);

        // Get first 4 messages (2 interactions max)
        const firstMessages = visibleMessages.slice(0, 4);

        // Count words from direct context (first messages)
        firstMessages.forEach((message) => {
          if (Array.isArray(message)) {
            // For message arrays, only count selected response or first one
            const msgToCount =
              message.find((msg) => msg.selected) || message[0];
            if (msgToCount && !msgToCount.hidden && msgToCount.data?.content) {
              total += store.countWords(msgToCount.data.content);
            }
          } else if (message.data?.content) {
            total += store.countWords(message.data.content);
          }
        });

        // Add file RAG words if files exist
        if (refFile?.some((file) => file.enabled)) {
          total += 300; // Fixed estimate for file RAG
        }

        // Add chat RAG words if beyond turn 3
        if (turnNumber >= 3) {
          total += 200; // Fixed estimate for chat RAG
        }
      }

      return total;
    }

    // If using standard pricing (perWord), count all words as before
    else {
      let total = 0;

      // Count words from files
      if (refFile && Array.isArray(refFile)) {
        refFile.forEach((file) => {
          if (file.metadata?.words && file.enabled) {
            total += file.metadata.words;
          }
        });
      }

      // Count words from all messages
      if (messages && Array.isArray(messages)) {
        messages.forEach((message) => {
          if (message.hidden) return;

          if (Array.isArray(message)) {
            // For arrays, only count selected response or first one if none selected
            const hasSelectedResponse = message.some((msg) => msg.selected);
            let wordsCounted = false;

            message.forEach((msg) => {
              if (
                !msg.hidden &&
                msg.data?.content &&
                (msg.selected || (!wordsCounted && !hasSelectedResponse))
              ) {
                total += store.countWords(msg.data.content);
                wordsCounted = true;
              }
            });
          } else if (message.data?.content) {
            total += store.countWords(message.data.content);
          }
        });
      }

      // Add current input text
      total += store.countWords(text || '');

      return total;
    }
  };
  const checkLimit = (text) => {
    if (
      !store.profile.wordcap_limits ||
      store.profile.wordcap_limits.words == 0
    )
      return false;
    return getChatWords(text) > store.profile.wordcap_limits.words;
  };

  // handle delete of a message
  const handleMessageDelete = (messageId) => {
    let previousUserMessageIndex = -1;

    // Map through messages to hide the target and keep track of the previous user message index
    const updatedMessages = messages.map((message, index) => {
      if (Array.isArray(message)) {
        const idx = message.findIndex((msg) => msg._id === messageId);
        if (idx !== -1) {
          if (previousUserMessageIndex === -1)
            previousUserMessageIndex = index - 1;
          // Hide all messages in this array
          return message.map((msg) => ({ ...msg, hidden: true }));
        }
      } else if (message._id === messageId) {
        previousUserMessageIndex = index - 1;
        return { ...message, hidden: true };
      }
      return message;
    });

    // Hide also the previous message
    if (
      previousUserMessageIndex >= 0 &&
      !Array.isArray(updatedMessages[previousUserMessageIndex])
    ) {
      updatedMessages[previousUserMessageIndex] = {
        ...updatedMessages[previousUserMessageIndex],
        hidden: true,
      };
    }

    // Create the updated chat object
    const updatedChat = {
      ...selectedChat.chat,
      messages: updatedMessages,
    };

    setXchatId(selectedChat.chat._id);
    setSelectedChat(updatedChat);
    setMessages(updatedMessages);
    getChat(selectedChat.chat._id);
  };

  // handle delete of a response
  const handleResponseDelete = (messageId) => {
    let state = { isSelected: false };
    const copy = JSON.parse(JSON.stringify(messages));
    const updatedMessages = findAndModifyMessage(
      copy,
      messageId,
      'hidden',
      true,
      state
    );

    const updatedChat = {
      ...selectedChat.chat,
      messages: updatedMessages,
    };

    setXchatId(selectedChat.chat._id);
    setSelectedChat(updatedChat);
    getChat(selectedChat.chat._id);
    setMessages([]);
  };

  const findAndModifyMessage = (
    messages,
    targetId,
    attributeName,
    newValue,
    state
  ) => {
    for (let item of messages) {
      if (Array.isArray(item)) {
        findAndModifyMessage(item, targetId, attributeName, newValue, state);
        if (state.isSelected) {
          const filteredMessages = item.filter((r) => r.hidden != true);
          changeOutput(filteredMessages[0]);
          state.isSelected = false;
        }
      } else if (item._id === targetId) {
        item[attributeName] = newValue;
        state.isSelected = item.selected;
        return messages;
      }
    }
    return messages;
  };

  const handleMouseEnter = useCallback((index) => {
    setHoveredIndex(index);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHoveredIndex(null);
  }, []);

  const removeImage = useCallback(
    (img) => {
      setImagesPreview((prevImagesPreview) => {
        let modified = prevImagesPreview.filter((item) => item._id !== img._id);
        return [...modified];
      });
    },
    [] // Eliminamos la dependencia de imagesPreview
  );

  const handleBadInteraction = (event) => {
    if (event.reason == 'bad model') {
      setShowFileDialog(false);
      setShowModelsDialog(true);
    }
  };

  const removeModel = (model) => {
    updateSelectedModels((prev) =>
      prev.filter((item) => item._id !== model._id)
    );
    localStorage.setItem(
      'currentModels',
      JSON.stringify(selectedModels.filter((item) => item._id !== model._id))
    );
    oldSelectedModels.current = sortByAttribute(
      selectedModels.filter((item) => item._id !== model._id),
      'abbreviation'
    );
    setEditMessChange();
  };
  //Pricing
  const [_, setRulesPlans] = useState([]);
  useEffect(() => {
    getRulesPlans();
  }, []);
  const getRulesPlans = async () => {
    try {
      setLoading(true);
      const res = await store.api.get('/user/constant', {
        params: {
          type: 'princing_plans',
        },
      });
      setRulesPlans(res.data.rules);
      setLoading(false);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      setLoading(false);
    }
  };

  const handleCapabilities = (capabilities) => {
    localStorage.setItem('capabilities', JSON.stringify(capabilities));
    setCapabilities(capabilities);
    addEvent(CAPABILITIES_CHANGE);
  };

  // Prompts Fav Handler
  const [straicoChoiceTools, setStraicoChoiceTools] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await store.api.get(`/v2/templates/straico-choice`);
        const priorityOrder = [
          'Flux Pro 1.1: Image generation', // Flux generator
          'Flux Pro 1.1: Prompt optimizer', // Flux optimizer
          'DALL-E 3: Image generation', // Dalle3 generator
          'DALL-E 3: Prompt optimizer', // Dalle3 optimizer
        ];
        const orderedTools = res.data.data.sort((a, b) => {
          const indexA = priorityOrder.indexOf(a.title);
          const indexB = priorityOrder.indexOf(b.title);
          return indexA - indexB;
        });
        setStraicoChoiceTools(orderedTools);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);
  const [loadingFavTools, setLoadingFavTools] = useState(false);
  const [favTools, setFavTools] = useState([]);

  const fetchFavs = async () => {
    setLoadingFavTools(true);
    try {
      const data = await store.fetchFavorites();
      if (data && data.data) {
        const filteredTools = data.data.filter((tool) => !tool.in_trash);
        setFavTools(sortArrayAlphabetically(filteredTools));
      } else {
        console.error('No favorite tools or unexpected format found:', data);
      }
    } catch (error) {
      console.error('Error getting favorite tools:', error);
    } finally {
      setLoadingFavTools(false);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (store.cachedFavoritesResponse) {
        clearInterval(intervalId);
        fetchFavs();
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [store]);

  const { theme: themeValue } = useThemeStore();

  const { setOpenPromptLibrary, openPromptLibrary } = usePromptLibraryStore();
  const togglePromptLibrary = () => setOpenPromptLibrary(!openPromptLibrary);

  // GET CATALOG TO FILTERS HOOK
  useCatalog(store);

  const [showDone, setShowDone] = useState(false);

  useEffect(() => {
    if (!optimizing && showDone) {
      const timer = setTimeout(() => {
        setShowDone(false);
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [optimizing, showDone]);

  const handleOptimizationComplete = () => {
    setOptimizing(false);
    setShowDone(true);
  };

  const getRenderIcon = (type, className = '', onClick) => {
    switch (type) {
      case TABS:
        return <TabsIcon className={className} onClick={onClick} />;
      case COLUMNS:
        return <ColumnsIcon className={className} onClick={onClick} />;
      case ROWS:
        return <RowsIcon className={className} onClick={onClick} />;
      case GRID:
        return <GridIcon className={className} onClick={onClick} />;
      default:
        break;
    }
  };

  const renderTypes = () => {
    const types = [
      { label: 'Columns layout', type: COLUMNS, icon: ColumnsIcon },
      { label: 'Rows layout', type: ROWS, icon: RowsIcon },
      { label: 'Grid layout', type: GRID, icon: GridIcon },
    ];
    return maxMessageModels > 2 || selectedModels.length > 2
      ? types
      : types.filter((e) => e.type != GRID);
  };

  const [maskEditorOpen, setMaskEditorOpen] = useState(false);
  const [maskEditorImage, setMaskEditorImage] = useState(null);

  const closeMaskEditor = () => {
    setMaskEditorImage(null);
    setMaskEditorOpen(false);
  };

  // Mover la creación del ImagePreview fuera del JSX y memoizarlo
  const memoizedImagePreview = useMemo(
    () => (
      <ImagePreview
        images={imagesPreview}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onRemove={removeImage}
        themeValue={themeValue}
        hoveredIndex={hoveredIndex}
      />
    ),
    [imagesPreview, hoveredIndex, themeValue]
  ); // Solo las dependencias que realmente cambian

  const checkErrorContext = useMemo(() => {
    const copy = JSON.parse(JSON.stringify(messages));
    const thread = copy.map((msg) => {
      if (!Array.isArray(msg)) {
        return msg;
      }

      return msg.find((m) => m.selected);
    });
    return (
      thread.length && thread.some((e) => !e || (e && e.error && e.error.type))
    );
  }, [selectedChat, loading, messages, editMessChange]);

  return (
    <>
      <Helmet>
        <title>Chat - Straico</title>
      </Helmet>

      <CoinsAlertModal
        handleConfirm={handleConfirmAlertCoins}
        customClose={handleCloseAlertCoins}
      />

      {isModelValidatorOpen && (
        <CapabilityModelValidator
          capabilitiesSelected={capabilities}
          modelsSelected={selectedModels}
          setModelsSelected={setSelectedModels}
          isOpen={isModelValidatorOpen}
          themeValue={themeValue}
          onInteraction={(models, newModels) => {
            if (addResponseModels) {
              setSelectedModels([...models, ...newModels]);
              onAddModels(newModels);
            } else {
              setSelectedModels(models);
            }
            closeModelValidator();
          }}
          onCapabilities={handleCapabilities}
          newModelsSelected={[]}
          setModelValidatorOpen={closeModelValidator}
        />
      )}

      {/* Chat */}
      <div
        className={`flex flex-col h-full w-full flex-1 items-center overflow-auto`}
      >
        {loadingBar && <LinearProgress />}

        <div className="flex-1 flex flex-col w-full h-full overflow-auto font-figtree">
          <div
            className={`h-full w-full bg-seasalt dark:bg-lead flex-1 flex flex-col overflow-auto ${powerPanelOpen
              ? 'md:max-w-[calc(100vw_-_16rem)]'
              : 'md:max-w-[calc(100vw_-_3.5rem)]'
              }`}
          >
            {!((messages.length || 0) > 0) && (
              <div className="mx-auto w-full lg:max-w-4xl">
                <AttachedFiles
                  files={refFile}
                  onFileChange={updateRefFile}
                  setShowFileDialog={setShowFileDialog}
                />
              </div>
            )}
            {(messages?.length || 0) > 0 || selectedChat.chat?._id ? (
              <div
                className={`flex flex-col flex-1 max-w-full h-full ${themeValue == 'dark' ? 'bg-lead' : 'bg-seasalt'
                  }`}
              >
                {/* Title chat - Top Bar */}
                <TitleBarChat
                  messages={messages}
                  goBackChat={goBackChat}
                  setDeleted={setDeleted}
                  setToDelete={setToDelete}
                  setShowEditDialog={setShowEditDialog}
                  setShowFileDialog={setShowFileDialog}
                  setShowClearDialog={setShowClearDialog}
                  setShowDeleteDialog={setShowDeleteDialog}
                  setShowDownloadDialog={setShowDownloadDialog}
                />
                {/* Messages between AI and user */}
                <div
                  ref={chatContainer}
                  className="overflow-auto flex flex-col-reverse overflow-rtl overflow-rtl-light dark:overflow-rtl-dark"
                  onScroll={handleScroll}
                >
                  {loading &&
                    (smartMode === 'on' ? (
                      <div className="py-8 w-full flex items-center justify-center">
                        <Loader color="accent" className="h-8 mr-2" />
                        {optimizing ? (
                          <span className="text-sm text-peachy-maroney font-semibold">
                            Optimizing your prompt...
                          </span>
                        ) : showDone ? (
                          <span className="text-sm text-peachy-maroney font-semibold">
                            Done!
                          </span>
                        ) : null}
                      </div>
                    ) : currentPrompt &&
                      ['image', 'fluxImage'].includes(currentPrompt.type) ? (
                      <ChatMessage
                        item={{
                          data: {
                            role: 'assistant',
                            content: handleBehaviourLoader(),
                          },
                          model: currentPrompt?.abbreviation,
                          date: moment().utc(),
                        }}
                        formatedDate={formatedDate}
                        readOnlyMessage
                        loading
                        optimizing
                      />
                    ) : (
                      <div className="py-8 w-full flex items-center justify-center">
                        <Loader className="h-8" />
                      </div>
                    ))}
                  {/* Streaming message */}
                  {!['image', 'fluxImage'].includes(currentPrompt?.type) && (
                    <StreamingMessage />
                  )}
                  {/** Render the memo messages */}
                  <ListingChatMessages
                    messages={messages}
                    loading={loading}
                    avatar={avatar}
                    xchatId={selectedChat?.chat?._id}
                    currentEvent={currentEvent}
                    handleScriptForTTS={handleScriptForTTS}
                    handleMessageDelete={handleMessageDelete}
                    handleResponseDelete={handleResponseDelete}
                    setDialogContent={setDialogContent}
                    setShowImageDialog={setShowImageDialog}
                    changeOutput={changeOutput}
                    capabilitiesList={capabilities}
                    onRegenerate={onRegenerate}
                    onRegenerateEdit={onRegenerateEdit}
                    continueResponse={continueResponse}
                    optimizing={optimizing}
                    calculateCoinsEdit={calculateCoinsEdit}
                    handleAddModels={handleAddModels}
                    onSend={onSend}
                    handleScrollRequest={handleScrollRequest}
                    streamCode={streamCode}
                    messageRefs={messageRefs}
                  />
                </div>
              </div>
            ) : (
              <>
                <div
                  className={`flex overflow-rtl ${themeValue == 'dark'
                    ? 'bg-lead overflow-rtl-dark'
                    : 'bg-seasalt overflow-rtl-light'
                    } overflow-auto flex-col h-full font-figtree px-9 justify-around lg:max-w-4xl w-full m-auto`}
                >
                  <section className="mb-6">
                    <article>
                      <h2
                        className={`text-[28px] font-bold leading-[28px] ${themeValue == 'dark' ? 'text-white' : 'text-black'
                          }`}
                      >
                        {welcomeMessage[0]}
                      </h2>
                      <p
                        className={`text-xl ${themeValue == 'dark' ? 'text-white' : 'text-black'
                          }`}
                      >
                        {welcomeMessage[1]}
                      </p>
                    </article>
                  </section>

                  {isMobile ? (
                    favTools.length > 0 ? (
                      <ScrollableToolsSection
                        title={
                          favTools.length === 0
                            ? 'No favorite templates'
                            : favTools.length === 1
                              ? 'Your favorite template'
                              : 'Your favorite templates'
                        }
                        tools={favTools}
                        isSmallMobile={true}
                        subTitle={
                          favTools.length === 0
                            ? "To add a prompt template to your favorites, simply click on the star ⭐️ on the template's description."
                            : ''
                        }
                      />
                    ) : (
                      <ScrollableToolsSection
                        title="Generate images with top AI models"
                        tools={straicoChoiceTools}
                        isSmallMobile={true}
                      />
                    )
                  ) : (
                    <>
                      <div>
                        {loadingFavTools ? (
                          <div>Loading...</div>
                        ) : (
                          <ScrollableToolsSection
                            title={
                              favTools.length === 0
                                ? 'No favorite templates'
                                : favTools.length === 1
                                  ? 'Your favorite template'
                                  : 'Your favorite templates'
                            }
                            tools={favTools}
                            isSmallMobile={true}
                            subTitle={
                              favTools.length === 0
                                ? "To add a prompt template to your favorites, simply click on the star ⭐️ on the template's description."
                                : ''
                            }
                          />
                        )}
                      </div>
                      <ScrollableToolsSection
                        title="Generate images with top AI models"
                        tools={straicoChoiceTools}
                        isSmallMobile={false}
                      />
                    </>
                  )}
                  <div
                    className={`flex flex-col w-full justify-end ${themeValue == 'dark'
                      ? 'text-stargate-shimmer'
                      : 'text-nue-blue'
                      } mt-2 items-end cursor-pointer`}
                  >
                    <div className="flex items-center gap-3">
                      <p
                        className="text-base leading-7 font-bold"
                        onClick={togglePromptLibrary}
                      >
                        Explore our prompt collection
                      </p>
                      <ArrowLongRightIcon className="h-4 w-4" />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Input field */}
          <div
            ref={inputContainerRef}
            className={`relative m-auto w-full pr-3 pb-2 flex items-start lg:max-w-4xl pt-4 ${themeValue == 'dark' ? 'bg-lead' : 'bg-seasalt'
              }`}
          >
            <div
              style={{
                transform: 'rotate(-90deg)',
                marginLeft: window.innerWidth < 768 ? '-10px' : '-25px',
                marginRight: window.innerWidth < 768 ? '-15px' : '-30px',
                marginTop: window.innerWidth < 768 ? '10px' : '15px',
              }}
            >
              <ToggleSmartMode />
            </div>
            {isRecording && (
              <div className="flex flex-col mt-2 md:ml-2.5">
                <div className="p-0">
                  <img
                    alt="record-gif"
                    src="/gifs/rec.gif"
                    className="h-6 w-6 m-auto justify-center"
                  />
                </div>
                <div
                  className={`px-1 font-figtree font-normal text-sm leading-5 text-center ${themeValue == 'dark' ? 'text-crystal-bell' : 'text-lead'
                    }`}
                >
                  {formatTime(recordingTime)}
                </div>
              </div>
            )}
            <ActionsChat
              loading={loading}
              messages={messages}
              onStop={onStop}
            />
            {!isRecording && (
              <div className="flex items-center gap-1 mr-1 -ml-1">
                <div className="flex h-12 justify-center items-center">
                  <Tooltip title="Attach a file" arrow placement="top">
                    <button
                      onClick={() => setShowFileDialog(true)}
                      className="md:hidden block w-12 h-12 p-1 text-agate-violet cursor-pointer select-none scale-x-[-1] focus:outline-none"
                    >
                      <PaperClipIcon className="w-10 h-10" />
                    </button>
                  </Tooltip>
                </div>
                <div className="flex h-12 justify-center items-center">
                  <Tooltip title="Select capabilities" arrow placement="top">
                    <button
                      onClick={() => {
                        setShowCapabilitiesDialog(true);
                      }}
                      className="flex items-center justify-center focus:outline-none -mt-1"
                    >
                      <CapabilitiesIcon className="md:hidden block w-8 h-8 text-agate-violet cursor-pointer select-none" />
                    </button>
                  </Tooltip>
                </div>
              </div>
            )}
            <label
              htmlFor="user-message"
              className="-mt-1 px-2 relative transition block w-full"
            >
              {inputValue?.length > 0 && (
                <div
                  className="absolute top-3 right-12 md:right-[132px] z-50 cursor-pointer"
                  onClick={() => setInputValue('')}
                >
                  <XMarkIcon
                    className={`w-4 ${themeValue == 'dark'
                      ? 'text-stargate-shimmer'
                      : 'text-violet-blue'
                      }`}
                  />
                </div>
              )}
              <TextAreaHightlight
                classNameContainer={`outline-none focus:outline-none text-md rounded w-full font-regular ${inputError ? 'border-red-400' : 'border-nue-blue'
                  } font-figtree shadow-none text-base`}
                textareaRef={textareaRef}
                autoFocus
                minRows={1}
                maxRows={7}
                onKeyDown={onEnterPress}
                onCompositionStart={handleCompositionStart}
                onCompositionEnd={handleCompositionEnd}
                value={inputValue}
                onChange={(value) => {
                  setInputValue(value);
                }}
                highlightWords={
                  themeValue == 'dark'
                    ? highlightWordsTextAreaV2Dark
                    : highlightWordsTextAreaV2
                }
                inputWarning={checkLimit(inputValue)}
                warningAction={onNewChat}
                onInteraction={(e) => addReferenceFile(e)}
                models={selectedModels}
                setShowFileDialog={setShowFileDialog}
                setShowCapabilitiesDialog={setShowCapabilitiesDialog}
                startRecording={startRecording}
                stopRecording={stopRecording}
                onSend={onSend}
                pricingMethod={store.profile.pricing_method}
                disabled={checkErrorContext}
                placeholder={
                  checkErrorContext
                    ? 'To continue, please replace any failed models or choose a valid response'
                    : "Chat here or type ' / ' for prompt templates"
                }
              >
                {memoizedImagePreview}
              </TextAreaHightlight>
              {maskEditorOpen && (
                <ImageMaskEditorModal
                  isOpen={maskEditorOpen}
                  onRequestClose={closeMaskEditor}
                  imageUrl={maskEditorImage}
                  store={store}
                  onSend={onSend}
                />
              )}

              <MenuActionsTextField
                ref={promptListRef}
                filteredOptions={filteredOptions}
                handleScriptForTTS={handleScriptForTTS}
                setShowClearDialog={setShowClearDialog}
                setShowModelsDialog={setShowModelsDialog}
              />
              <TemplateModal
                onClose={handleCloseTemplateModal}
                handleSubmitModal={checkTemplateModel}
                handleTemplateModel={handleTemplateModel}
              />
              <DeleteTemplateModal />
              {selectedModels.length > 0 && (
                <div className="flex gap-1 mt-1 font-figtree text-xs items-center justify-end">
                  {isVoiceProcessing && (
                    <div
                      className={`w-full h-3.5 flex items-center justify-center animate-pulse rounded ${themeValue === 'dark' ? 'bg-[#7379FF]' : 'bg-[#464BBA]'
                        } relative`}
                    >
                      <span
                        className={`font-bold text-[8px] ${themeValue === 'dark'
                          ? 'text-[#F7F7F8]'
                          : 'text-[#EFEFEF]'
                          }`}
                      >
                        LOADING...
                      </span>
                    </div>
                  )}
                  {store.profile.pricing_method !== 'perMessage' && (
                    <>
                      <Tooltip
                        title={
                          <>
                            Current words / <br /> Max allowed in context
                          </>
                        }
                        arrow
                        placement="left-end"
                      >
                        <div
                          className={`${themeValue == 'dark'
                            ? 'text-sonic-silver '
                            : 'text-cool-gray '
                            } font-medium`}
                        >
                          <span
                            className={`${getChatWords(inputValue) >
                              getVisibleModel().words_text && 'text-red-600'
                              }`}
                          >
                            {getChatWords(inputValue).toLocaleString('en-US')}
                          </span>
                          /
                          {getVisibleModel().words_text.toLocaleString('en-US')}
                        </div>
                      </Tooltip>
                      <Tooltip
                        title="About wordcap limit"
                        arrow
                        placement="left-end"
                      >
                        <Shortcut
                          className={`rounded-full cursor-pointer relative group flex flex-col items-center group ${checkLimit(inputValue)
                            ? 'text-white'
                            : themeValue === 'dark'
                              ? 'text-sonic-silver'
                              : 'text-cool-gray'
                            }`}
                          style={{
                            color: checkLimit(inputValue)
                              ? '#E2B36C'
                              : undefined,
                          }}
                          onClick={() => setShowLimitDialog(true)}
                        >
                          <InformationCircleIcon className="w-4 h-4" />
                        </Shortcut>
                      </Tooltip>
                    </>
                  )}
                  <Tooltip
                    title={
                      store.profile.pricing_method === 'perMessage' ? (
                        'Pricing per Message: fixed cost per message'
                      ) : (
                        <>
                          Minimum cost of <br /> next interaction
                        </>
                      )
                    }
                    arrow
                    placement="left-end"
                  >
                    <div
                      className={`
          flex flex-row items-center px-[2px] rounded-[20px] font-semibold py-[2px] cursor-pointer
          ${store.profile.pricing_method === 'perMessage'
                          ? 'border border-[#f2a474] bg-transparent neon-effect-custom border-neon-custom text-[#f2a474]'
                          : getCostDisplayClass()
                        }
        `}
                      onClick={() => setCostModalOpen(true)}
                    >
                      <StraiCoinIcon
                        className={`w-4 h-4 ${store.profile.pricing_method === 'perMessage'
                          ? 'text-[#f2a474]'
                          : 'text-white'
                          }`}
                      />
                      <span
                        className={`mx-1 ${store.profile.pricing_method === 'perMessage'
                          ? 'text-[#f2a474]'
                          : 'text-white'
                          }`}
                      >
                        {calculateCoins(getChatWords(inputValue))}
                      </span>
                    </div>
                  </Tooltip>
                </div>
              )}
            </label>

            {inputValue?.length == 0 && (
              <div className="md:hidden flex h-12 justify-center flex-col items-center">
                {isRecording ? (
                  <Tooltip title="Finish recording" arrow placement="top-end">
                    <StopIcon
                      className="w-8 h-8 text-red-500 cursor-pointer select-none"
                      onClick={() => stopRecording()}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title="Record prompt" arrow placement="top-end">
                    <MicrophoneIcon
                      className="w-8 h-8 text-agate-violet cursor-pointer select-none"
                      onClick={() => startRecording()}
                    />
                  </Tooltip>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {showDeleteDialog && (
        <DeleteChat
          deleted={deleted}
          setDeleted={setDeleted}
          onDelete={onDelete}
          onClose={() => setShowDeleteDialog(false)}
        />
      )}
      {showWarningDialog && (
        <ModelWarningDialog
          data={toolData.current}
          onContinue={(data) =>
            handleSubmitModal(
              data.updatedVariables,
              data.templateData,
              true,
              runSampleAutoFlag
            )
          }
          onContinueWithCurrentModels={(data) =>
            handleSubmitModal(
              data.updatedVariables,
              data.templateData,
              false,
              runSampleAutoFlag
            )
          }
          onClose={() => setShowWarningDialog(false)}
        />
      )}
      {showLimitDialog && (
        <WordcapLimitsDialog
          open={showLimitDialog}
          exceeded={checkLimit(inputValue)}
          onClose={() => setShowLimitDialog(false)}
        />
      )}
      {showEditDialog && (
        <EditTitle chat={selectedChat.chat} onInteraction={onEdit} />
      )}
      {showDownloadDialog && (
        <DownloadChat
          chatId={selectedChat?.chat?._id}
          onClose={() => setShowDownloadDialog(false)}
          onDownloadTxt={() => {
            onDownloadChat(selectedChat?.chat?._id);
            setShowDownloadDialog(false);
          }}
          onDownloadPdf={() => {
            onDownloadChatPDF(selectedChat?.chat?._id);
            setShowDownloadDialog(false);
          }}
        />
      )}
      {showFileDialog && (
        <FileContext
          onInteraction={(e) => addReferenceFile(e)}
          onClose={() => setShowFileDialog(false)}
          models={selectedModels}
          onBadInteraction={handleBadInteraction}
        />
      )}
      {showTextSpeechDialog && (
        <TextSpeechDialog
          onClose={() => setShowTextSpeechDialog(false)}
          script={scriptValue}
        />
      )}
      {showModelsDialog && (
        <ModelsModal
          open={showModelsDialog}
          selectedModels={selectedModels}
          onCapabilities={handleCapabilities}
          selectedCapabilities={capabilities}
          setSelectedModels={(models) => {
            if (addResponseModels) {
              onAddModels(models);
            } else {
              setSelectedModels(models);
            }
            setShowModelsDialog(false);
            setReplaceResponse(null);
          }}
          onClose={() => {
            setShowModelsDialog(false);
            setReplaceResponse(null);
          }}
          themeValue={themeValue}
          maxModels={
            replaceResponse ? selectedModels.length + 1 : MAX_MODELS_SELECTION
          }
        />
      )}
      {costModalOpen && (
        <CostInfoModal
          open={costModalOpen}
          onClose={() => setCostModalOpen(false)}
          costValue={calculateCoins(getChatWords(inputValue))}
          wordCount={getChatWords(inputValue)}
          pricingDetails={
            store.profile.pricing_method === 'perMessage'
              ? {
                basePrice: selectedModels[0]?.pricing?.coins || 0,
                maxMultiplier: parseFloat(
                  import.meta.env.VITE_PPI_MULTIPLIER || 15
                ),
                scaleFactor: 1000.0,
                exponent: 1.5954,
                ragInfo: {
                  chatRagWords: 200,
                  fileRagWords: 300,
                  hasFiles: refFile?.some((file) => file.enabled) || false,
                  turnThreshold: 3,
                  currentTurn: messages
                    ? Math.ceil(
                      messages.filter((msg) => !msg.hidden).length / 2
                    )
                    : 0,
                },
              }
              : null
          }
          onActivateSmartPricing={() => updatePricingMethod('perMessage')}
          onDeactivateSmartPricing={() => updatePricingMethod('perWord')}
          currentPricingMethod={store.profile.pricing_method}
        />
      )}
      {showClearDialog && (
        <ClearChat
          cleared={cleared}
          setCleared={setCleared}
          onClear={onClear}
          onClose={() => setShowClearDialog(false)}
        />
      )}
      {showCapabilitiesDialog && (
        <CapabilitySelector
          selectedModels={selectedModels}
          open={showCapabilitiesDialog}
          onInteraction={(models, newModels) => {
            if (addResponseModels) {
              setSelectedModels([...models, ...newModels]);
              onAddModels(newModels);
            } else {
              setSelectedModels(models);
            }
          }}
          onClose={() => setShowCapabilitiesDialog(false)}
          onCapabilities={handleCapabilities}
          selectedCapabilities={capabilities}
        />
      )}
      {showImageDialog && (
        <ImageDialog onClose={() => setShowImageDialog(false)}>
          {dialogContent}
        </ImageDialog>
      )}
      {openPromptLibrary && <PromptLibrary />}
      <FavoriteMessages
        onSelectChat={onSelectChat}
        avatar={avatar}
        onLoading={(e) => setLoadingBar(e)}
      />
      {openShareChatModal && (
        <ShareChat
          chat={selectedChat?.chat}
          messages={messages}
          renderChat={
            <ListingChatMessages
              messages={messages}
              loading={loading}
              avatar={avatar}
              xchatId={xchatId}
              formatedDate={formatedDate}
              handleScriptForTTS={handleScriptForTTS}
              handleMessageDelete={handleMessageDelete}
              handleResponseDelete={handleResponseDelete}
              setLoadingBar={setLoadingBar}
              setDialogContent={setDialogContent}
              setShowImageDialog={setShowImageDialog}
              changeOutput={changeOutput}
              capabilitiesList={capabilities}
              onRegenerate={onRegenerate}
              onRegenerateEdit={onRegenerateEdit}
              continueResponse={continueResponse}
              optimizing={optimizing}
              calculateCoinsEdit={calculateCoinsEdit}
              handleAddModels={handleAddModels}
              onSend={onSend}
              handleScrollRequest={handleScrollRequest}
              streamCode={streamCode}
              messageRefs={messageRefs}
              store={store}
            />
          }
          capabilities={capabilities}
        />
      )}
    </>
  );
};

export { onNewChat };
export default inject('store')(observer(Chat));
